import React, { useState, useEffect, useRef } from 'react';
import { getAuth, signOut, updatePassword } from 'firebase/auth';
import { doc, getDoc,getFirestore , updateDoc, collection, query, where, getDocs, orderBy, serverTimestamp, addDoc, onSnapshot, setDoc, Timestamp, limit } from 'firebase/firestore';
import { db } from '../components/firebase-config.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Modal, Button, Alert, Card } from 'react-bootstrap';
import {
  getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL, deleteObject
} from 'firebase/storage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPaperPlane,
  faUser,
  faSearch,
  faPaperclip,
  faVideo,
  faMicrophone,
  faImage,
  faFile,
  faDownload,
  faTrashAlt,
  faCircleNotch,
  faTimes,
  faCheck,
  faEllipsisV,
  faInfoCircle,
  faPhoneAlt,
  faEnvelopeOpen,
  faCalendarCheck,
  faUserMd,
  faClock,
  faMapMarkerAlt,
  faBriefcaseMedical,
  faHospital,
  faHome,
  faPlus,
  faBell,
  faCalendarAlt,
  faComments,
  faBuilding,
  faShieldAlt,
  faBars,
  faChevronLeft,
  faChevronRight,
  faList,
  faEye
} from '@fortawesome/free-solid-svg-icons';
import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, 
         addDays, isSameMonth, isSameDay, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import axios from 'axios';


const PatientDashboard = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('rendezvous');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [calendarView, setCalendarView] = useState(true);
  const [selectedSpeciality, setSelectedSpeciality] = useState('');

  // États pour les données du patient
  const [patient, setPatient] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    dateNaissance: '',
    adresse: '',
    sexe: '',
    numeroAssurance: '',
    assurances: [],
    antecedentsMedicaux: ''
  });
  
  // États pour les structures et médecins
  const [structures, setStructures] = useState([]);
  const [selectedStructure, setSelectedStructure] = useState('');
  const [medecins, setMedecins] = useState([]);
  const [filteredMedecins, setFilteredMedecins] = useState([]);
  const [selectedMedecin, setSelectedMedecin] = useState('');
  
  // États pour les rendez-vous
  const [rendezvous, setRendezvous] = useState([]);
  const [affiliations, setAffiliations] = useState([]);
  
  // État pour le formulaire de demande de rendez-vous
  const [rdvFormData, setRdvFormData] = useState({
    date: '',
    heure: '',
    motif: '',
    structureId: '',
    medecinId: '',
    urgent: false
  });
  
  // État pour le changement de mot de passe
  const [passwordData, setPasswordData] = useState({
    newPassword: '',
    confirmPassword: ''
  });

  // Nouvel état pour la recherche de structures
  const [structureSearchTerm, setStructureSearchTerm] = useState('');
  
  // Nouvel état pour le formulaire de demande d'affiliation directe
  const [affiliationFormData, setAffiliationFormData] = useState({
    structureId: '',
    motif: ''
  });

  // Nouveaux états pour les notifications
  const [newRendezvousCount, setNewRendezvousCount] = useState(0);
  const [newAffiliationsCount, setNewAffiliationsCount] = useState(0);
  const [viewedRdv, setViewedRdv] = useState([]);
  const [viewedAffiliations, setViewedAffiliations] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);

  // États pour le paiement
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [currentPaymentRequest, setCurrentPaymentRequest] = useState(null);
// États pour la messagerie
const [conversations, setConversations] = useState([]);
const [selectedConversation, setSelectedConversation] = useState(null);
const [messages, setMessages] = useState([]);
const [newMessage, setNewMessage] = useState('');
const [loadingMessages, setLoadingMessages] = useState(false);
const messagesEndRef = useRef(null);
const [attachmentPreview, setAttachmentPreview] = useState(null);
const [attachment, setAttachment] = useState(null);
const [sendingMessage, setSendingMessage] = useState(false);

  // Configuration PayTech
  const payTechConfig = {
    api_key: "0360fc1c628c4527a6035a75d63bbd9ec2ad27da5e56b39be53019a36578c80c",
    api_secret: "3f2048b8e427fa67a3a6341bcfe3795abc05cdd68ad101d6f51ebe6734340b9c",
    env: "test",
    ipn_url: "https://drmarndiayeophtalmo.com/PatientDashboard/ipn",
    success_url: "https://drmarndiayeophtalmo.com/PatientDashboard",
    cancel_url: "https://drmarndiayeophtalmo.com/PatientDashboard"
  };

  // Inside the PatientDashboard component, add these new state variables:
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [appointmentsByDate, setAppointmentsByDate] = useState({});

  // Dans la partie où sont définis les états, ajouter un nouvel état pour les messages non lus
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  // Ajouter avant la définition de CalendarView
  const selectedDateAppointments = selectedDate 
    ? rendezvous.filter(rdv => {
        if (!rdv.date) return false;
        return isSameDay(parseISO(rdv.date), selectedDate);
      })
    : [];

  // Vérifier si l'appareil est mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Charger les données du patient au chargement de la page
  useEffect(() => {
    const fetchPatientData = async () => {
      if (!auth.currentUser) {
        navigate('/');
        return;
      }
      
      try {
        const patientDoc = await getDoc(doc(db, 'patients', auth.currentUser.uid));
        if (patientDoc.exists()) {
          const patientData = patientDoc.data();
          setPatient(patientData);
          setFormData({
            nom: patientData.nom || '',
            prenom: patientData.prenom || '',
            email: patientData.email || '',
            telephone: patientData.telephone || '',
            dateNaissance: patientData.dateNaissance || '',
            adresse: patientData.adresse || '',
            sexe: patientData.sexe || '',
            numeroAssurance: patientData.numeroAssurance || '',
            assurances: patientData.assurances || [],
            antecedentsMedicaux: patientData.antecedentsMedicaux || ''
          });
          
          // Charger les structures médicales
          fetchStructures();
          
          // Charger les affiliations
          const unsubscribeAffiliations = fetchAffiliations();
          
          // Charger les rendez-vous
          const unsubscribeRdv = fetchRendezvous();
          
          // Charger les rendez-vous et affiliations déjà vus
          const viewedRdvData = localStorage.getItem(`viewedRdv_${auth.currentUser.uid}`);
          if (viewedRdvData) {
            setViewedRdv(JSON.parse(viewedRdvData));
          }
          
          const viewedAffiliationsData = localStorage.getItem(`viewedAffiliations_${auth.currentUser.uid}`);
          if (viewedAffiliationsData) {
            setViewedAffiliations(JSON.parse(viewedAffiliationsData));
          }
          
          // Charger les notifications du patient
          fetchNotifications();
          
          return () => {
            if (unsubscribeAffiliations) unsubscribeAffiliations();
            if (unsubscribeRdv) unsubscribeRdv();
          };
        } else {
          setError("Données du patient non trouvées");
          navigate('/');
        }
      } catch (err) {
        setError("Erreur lors du chargement des données: " + err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchPatientData();
  }, [auth.currentUser, navigate]);
  
  // Vérifier le statut du paiement au chargement de la page (retour de PayTech)
  useEffect(() => {
    const checkPaymentStatus = async () => {
      // Récupérer les paramètres d'URL pour vérifier le retour de paiement
      const urlParams = new URLSearchParams(window.location.search);
      const paymentStatus = urlParams.get('payment_status');
      const requestId = urlParams.get('request_id');
      
      if (paymentStatus && requestId) {
        try {
          setLoading(true);
          
          // Récupérer les données complètes depuis Firestore
          const pendingRequestRef = doc(db, "pendingPaymentRequests", requestId);
          const pendingRequestDoc = await getDoc(pendingRequestRef);
          
          if (pendingRequestDoc.exists()) {
            const requestData = pendingRequestDoc.data();
            
            // Mettre à jour l'état du composant avec les données récupérées
            setCurrentPaymentRequest(requestData);
            
            if (paymentStatus === 'success') {
              // Mettre à jour le statut dans Firestore
              await updateDoc(pendingRequestRef, {
                status: "payment_success",
                completedAt: new Date().toISOString()
              });
              
              // Finaliser la demande avec les données de Firestore
              await finalizeRequest(requestData);
              
              // Afficher un message de succès
              setMessage("Paiement réussi! Votre demande a été enregistrée.");
            } else if (paymentStatus === 'cancel') {
              // Mettre à jour le statut dans Firestore
              await updateDoc(pendingRequestRef, {
                status: "payment_cancelled",
                cancelledAt: new Date().toISOString()
              });
              
              setPaymentStatus({
                success: false,
                message: "Le paiement a été annulé."
              });
              
              // Afficher une notification d'annulation
              setError("Le paiement a été annulé.");
            }
            
            // Nettoyer l'URL
            window.history.replaceState({}, document.title, window.location.pathname);
          } else {
            console.error("La demande de paiement n'a pas été trouvée dans Firestore");
            setError("Impossible de retrouver les détails de votre paiement.");
          }
        } catch (error) {
          console.error("Erreur lors du traitement du retour de paiement:", error);
          setError("Une erreur est survenue lors du traitement de votre paiement.");
        } finally {
          setLoading(false);
        }
      }
    };
    
    checkPaymentStatus();
  }, []);
  
  // Mettre à jour les compteurs de notifications
  useEffect(() => {
    // Compter les nouveaux rendez-vous
    const newRdv = rendezvous.filter(rdv => 
      !viewedRdv.includes(rdv.id) && 
      new Date(rdv.createdAt?.toDate() || Date.now()) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    );
    setNewRendezvousCount(newRdv.length);
    
    // Compter les nouvelles affiliations
    const newAffiliations = affiliations.filter(affiliation => 
      !viewedAffiliations.includes(affiliation.id) && 
      (affiliation.statut === 'acceptée' || affiliation.statut === 'refusée') &&
      new Date(affiliation.updatedAt?.toDate() || affiliation.createdAt?.toDate() || Date.now()) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    );
    setNewAffiliationsCount(newAffiliations.length);
  }, [rendezvous, affiliations, viewedRdv, viewedAffiliations]);
  
  // Marquer les rendez-vous comme vus lorsqu'on visite l'onglet
  useEffect(() => {
    if (activeTab === 'rendezvous' && newRendezvousCount > 0) {
      const newViewedRdv = [...viewedRdv];
      
      rendezvous.forEach(rdv => {
        if (!newViewedRdv.includes(rdv.id)) {
          newViewedRdv.push(rdv.id);
        }
      });
      
      setViewedRdv(newViewedRdv);
      localStorage.setItem(`viewedRdv_${auth.currentUser.uid}`, JSON.stringify(newViewedRdv));
      setNewRendezvousCount(0);
    }
  }, [activeTab, rendezvous, newRendezvousCount, viewedRdv, auth.currentUser]);
  
  // Marquer les affiliations comme vues lorsqu'on visite l'onglet
  useEffect(() => {
    if (activeTab === 'affiliations' && newAffiliationsCount > 0) {
      const newViewedAffiliations = [...viewedAffiliations];
      
      affiliations.forEach(affiliation => {
        if (!newViewedAffiliations.includes(affiliation.id)) {
          newViewedAffiliations.push(affiliation.id);
        }
      });
      
      setViewedAffiliations(newViewedAffiliations);
      localStorage.setItem(`viewedAffiliations_${auth.currentUser.uid}`, JSON.stringify(newViewedAffiliations));
      setNewAffiliationsCount(0);
    }
  }, [activeTab, affiliations, newAffiliationsCount, viewedAffiliations, auth.currentUser]);
  
  // Charger les structures médicales
  const fetchStructures = async () => {
    try {
      const structuresQuery = query(collection(db, 'structures'));
      
      const unsubscribe = onSnapshot(structuresQuery, (snapshot) => {
        const structuresList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setStructures(structuresList);
      });
      
      return unsubscribe;
    } catch (err) {
      setError("Erreur lors du chargement des structures: " + err.message);
      return null;
    }
  };
  
  // Charger les affiliations du patient
  const fetchAffiliations = async () => {
    try {
      const affiliationsQuery = query(
        collection(db, 'affiliations'), 
        where('patientId', '==', auth.currentUser.uid)
      );
      
      const unsubscribe = onSnapshot(affiliationsQuery, (snapshot) => {
        const affiliationsList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setAffiliations(affiliationsList);
      });
      
      return unsubscribe;
    } catch (err) {
      setError("Erreur lors du chargement des affiliations: " + err.message);
      return null;
    }
  };
  
  // Charger les notifications du patient
  const fetchNotifications = async () => {
    try {
      const notificationsQuery = query(
        collection(db, 'notifications'),
        where('userId', '==', auth.currentUser.uid),
        orderBy('createdAt', 'desc'),
        limit(20)
      );
      
      const unsubscribe = onSnapshot(notificationsQuery, (snapshot) => {
        const notifList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        // Mettre à jour l'état des notifications
        setNotifications(notifList);
        
        // Compter les notifications non lues
        const unreadCount = notifList.filter(notif => !notif.read).length;
        setUnreadNotificationsCount(unreadCount);
      });
      
      return unsubscribe;
    } catch (err) {
      console.error("Erreur lors du chargement des notifications:", err);
      return null;
    }
  };
  
  // Fonction pour marquer une notification comme lue
  const markNotificationAsRead = async (notificationId) => {
    try {
      if (!notificationId) return;
      
      const notificationRef = doc(db, 'notifications', notificationId);
      await updateDoc(notificationRef, {
        read: true,
        readAt: serverTimestamp()
      });
      
      // Mise à jour locale de l'état (optimistic update)
      setNotifications(currentNotifications => 
        currentNotifications.map(notif => 
          notif.id === notificationId 
            ? { ...notif, read: true, readAt: new Date() } 
            : notif
        )
      );
      
      // Mettre à jour le compteur de notifications non lues
      setUnreadNotificationsCount(prevCount => Math.max(0, prevCount - 1));
      
    } catch (error) {
      console.error("Erreur lors du marquage de la notification comme lue:", error);
    }
  };
  
  // Charger les rendez-vous du patient
  const fetchRendezvous = async () => {
    try {
      const rdvQuery = query(
        collection(db, 'rendezvous'), 
        where('patientId', '==', auth.currentUser.uid)
      );
      
      const unsubscribe = onSnapshot(rdvQuery, async (snapshot) => {
        const rdvList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setRendezvous(rdvList);
        
        // Récupérer les IDs uniques des médecins des rendez-vous
        const medecinIds = [...new Set(rdvList.map(rdv => rdv.medecinId))];
        
        // Si nous avons des médecins à charger
        if (medecinIds.length > 0) {
          try {
            // Récupérer chaque médecin individuellement car Firestore ne supporte pas 'where in' avec trop d'éléments
            const medecinPromises = medecinIds.map(async (medecinId) => {
              if (!medecinId) return null;
              const medecinDoc = await getDoc(doc(db, 'medecins', medecinId));
              if (medecinDoc.exists()) {
                return { id: medecinDoc.id, ...medecinDoc.data() };
              }
              return null;
            });
            
            // Attendre que toutes les promesses soient résolues
            const medecinsResults = await Promise.all(medecinPromises);
            
            // Filtrer les résultats null et mettre à jour l'état des médecins
            const validMedecins = medecinsResults.filter(m => m !== null);
            
            // Fusionner avec les médecins existants pour ne pas perdre ceux déjà chargés
            setMedecins(prevMedecins => {
              const newMedecins = [...prevMedecins];
              
              // Ajouter uniquement les médecins qui ne sont pas déjà dans la liste
              validMedecins.forEach(medecin => {
                if (!newMedecins.some(m => m.id === medecin.id)) {
                  newMedecins.push(medecin);
                }
              });
              
              return newMedecins;
            });
          } catch (err) {
            console.error("Erreur lors du chargement des médecins des rendez-vous:", err);
          }
        }
      });
      
      return unsubscribe;
    } catch (err) {
      setError("Erreur lors du chargement des rendez-vous: " + err.message);
      return null;
    }
  };
  
  // Charger les médecins d'une structure
  const fetchMedecins = async (structureId) => {
    try {
      const medecinsQuery = query(
        collection(db, 'medecins'), 
        where('structureId', '==', structureId)
      );
      
      const medecinsSnapshot = await getDocs(medecinsQuery);
      const medecinsList = medecinsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMedecins(medecinsList);
      setFilteredMedecins(medecinsList);
    } catch (err) {
      setError("Erreur lors du chargement des médecins: " + err.message);
    }
  };
  
  // Gérer le changement de structure sélectionnée
  const handleStructureChange = (e) => {
    const structureId = e.target.value;
    setSelectedStructure(structureId);
    setRdvFormData({...rdvFormData, structureId: structureId, medecinId: ''});
    setSelectedMedecin('');
    
    if (structureId) {
      fetchMedecins(structureId);
    } else {
      setMedecins([]);
      setFilteredMedecins([]);
    }
  };
  
  // Filtrer les médecins par spécialité
  const handleSpecialiteFilter = (specialite) => {
    setSelectedSpeciality(specialite);
    
    if (specialite === '') {
      setFilteredMedecins(medecins);
    } else {
      const filtered = medecins.filter(medecin => 
        medecin.specialite.toLowerCase().includes(specialite.toLowerCase())
      );
      setFilteredMedecins(filtered);
    }
  };
  
  // Gérer le changement de médecin sélectionné
  const handleMedecinChange = (e) => {
    const medecinId = e.target.value;
    setSelectedMedecin(medecinId);
    setRdvFormData({...rdvFormData, medecinId: medecinId});
  };
  
  // Mettre à jour les données du profil
  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    
    try {
      await updateDoc(doc(db, 'patients', auth.currentUser.uid), {
        nom: formData.nom,
        prenom: formData.prenom,
        telephone: formData.telephone,
        dateNaissance: formData.dateNaissance,
        adresse: formData.adresse,
        sexe: formData.sexe,
        numeroAssurance: formData.numeroAssurance,
        assurances: formData.assurances,
        antecedentsMedicaux: formData.antecedentsMedicaux
      });
      
      setPatient({...patient, ...formData});
      setEditMode(false);
      setMessage("Profil mis à jour avec succès");
      
      setTimeout(() => {
        setMessage("");
      }, 3000);
    } catch (err) {
      setError("Erreur lors de la mise à jour du profil: " + err.message);
    }
  };
  
  // Changer le mot de passe
  const handleChangePassword = async (e) => {
    e.preventDefault();
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }
    
    try {
      await updatePassword(auth.currentUser, passwordData.newPassword);
      setMessage("Mot de passe mis à jour avec succès");
      setPasswordData({newPassword: '', confirmPassword: ''});
      
      setTimeout(() => {
        setMessage("");
      }, 3000);
    } catch (err) {
      setError("Erreur lors du changement de mot de passe: " + err.message);
    }
  };
  
  // Ajouter/retirer une assurance
  const handleAssuranceChange = (assurance) => {
    const currentAssurances = [...formData.assurances];
    if (currentAssurances.includes(assurance)) {
      setFormData({
        ...formData,
        assurances: currentAssurances.filter(a => a !== assurance)
      });
    } else {
      setFormData({
        ...formData,
        assurances: [...currentAssurances, assurance]
      });
    }
  };
  
  // Gérer les changements dans le formulaire de rendez-vous
  const handleRdvFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setRdvFormData({
      ...rdvFormData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  // Fonction d'initialisation du paiement
  const initiatePayment = async (requestData) => {
    try {
      setIsProcessingPayment(true);
      setPaymentStatus(null);
      
      // Générer un ID unique pour cette demande de paiement
      const paymentRequestId = `pay_${Date.now()}_${auth.currentUser.uid.substring(0, 8)}`;
      const refCommand = `RDV-${paymentRequestId}`;
      const customerId = `PATIENT-${auth.currentUser.uid}`;
      
      // 1. Sauvegarder d'abord la demande dans Firestore
      const pendingRequestRef = doc(db, "pendingPaymentRequests", paymentRequestId);
      await setDoc(pendingRequestRef, {
        ...requestData,
        paymentRequestId,
        paymentRef: refCommand,
        status: "pending_payment",
        createdAt: new Date().toISOString(),
        patientId: auth.currentUser.uid
      });
      
      // Montant du paiement (consultation)
      const consultationFee = 200; // 200 XOF
      
      // 2. Préparer les URLs avec l'ID de la demande en paramètre
      const successUrl = `${payTechConfig.success_url}?payment_status=success&request_id=${paymentRequestId}`;
      const cancelUrl = `${payTechConfig.cancel_url}?payment_status=cancel&request_id=${paymentRequestId}`;
      
      const paymentData = {
        item_name: `Consultation ${requestData.specialite || 'médicale'}`,
        item_price: consultationFee,
        currency: "XOF",
        ref_command: refCommand,
        command_name: `Consultation médicale via PayTech`,
        env: payTechConfig.env,
        ipn_url: payTechConfig.ipn_url,
        success_url: successUrl,
        cancel_url: cancelUrl,
        customer_id: customerId,
        customer_email: patient?.email || "",
        customer_phone_number: patient?.telephone || "",
        customer_address: patient?.adresse || "",
        customer_city: "Dakar",
        customer_country: "SN",
        customer_state: "Dakar",
        customer_zip_code: "12345"
      };
      
      console.log("Envoi des données à PayTech:", paymentData);
      
      const response = await fetch('https://paytech.sn/api/payment/request-payment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'API_KEY': payTechConfig.api_key,
          'API_SECRET': payTechConfig.api_secret
        },
        body: JSON.stringify(paymentData)
      });
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status} ${response.statusText}`);
      }
      
      const responseData = await response.json();
      console.log("Réponse de PayTech:", responseData);
      
      if (responseData && responseData.success) {
        // 3. Mettre à jour la demande dans Firestore avec le token PayTech
        await updateDoc(pendingRequestRef, {
          paymentToken: responseData.token,
          paymentAmount: consultationFee,
          paymentUrl: responseData.redirect_url,
          lastUpdated: new Date().toISOString()
        });
        
        // 4. Rediriger vers l'URL de paiement
        window.location.href = responseData.redirect_url;
      } else {
        setIsProcessingPayment(false);
        setPaymentStatus({
          success: false,
          message: responseData?.message || "Le paiement a échoué",
          data: responseData
        });
        
        // Mettre à jour le statut dans Firestore
        await updateDoc(pendingRequestRef, {
          status: "payment_failed",
          errorMessage: responseData?.message || "Le paiement a échoué",
          lastUpdated: new Date().toISOString()
        });
      }
    } catch (error) {
      setIsProcessingPayment(false);
      console.error('Erreur lors de l\'initialisation du paiement:', error);
      setPaymentStatus({
        success: false,
        message: "Une erreur est survenue lors de l'initialisation du paiement",
        error: error.message
      });
    }
  };
  
  // Fonction pour finaliser la demande après un paiement réussi
  const finalizeRequest = async (requestData) => {
    setLoading(true);
    try {
      // Date actuelle pour l'horodatage du paiement
      const paymentDate = new Date().toISOString();
      
      // Vérifier si patient existe avant d'accéder à ses propriétés
      const patientName = patient ? `${patient.prenom} ${patient.nom}` : "Patient";
      
      // Créer la demande de rendez-vous dans Firestore avec les détails de paiement
      const requestRef = await addDoc(collection(db, "rendezvous"), {
        patientId: auth.currentUser.uid,
        patientNom: patientName,
        structureId: requestData.structureId,
        medecinId: requestData.medecinId,
        date: requestData.date,
        heure: requestData.heure,
        motif: requestData.motif,
        urgent: requestData.urgent || false,
        statut: "confirmé",
        createdAt: new Date(),
        paymentStatus: "completed",
        paymentRef: requestData.paymentRef,
        paymentToken: requestData.paymentToken,
        paymentAmount: requestData.paymentAmount || 200,
        paymentDate: paymentDate,
        paymentMethod: "PayTech",
        paymentCurrency: "XOF",
        paymentRequestId: requestData.paymentRequestId
      });

      // Créer une notification pour le patient
      await addDoc(collection(db, "notifications"), {
        userId: auth.currentUser.uid,
        title: "Demande de rendez-vous envoyée",
        message: `Votre demande de rendez-vous a été envoyée. Paiement effectué.`,
        type: "request_pending",
        requestId: requestRef.id,
        createdAt: paymentDate,
        read: false
      });

      // Créer une entrée de transaction de paiement
      await addDoc(collection(db, "payments"), {
        userId: auth.currentUser.uid,
        requestId: requestRef.id,
        amount: requestData.paymentAmount || 200,
        currency: "XOF",
        paymentRef: requestData.paymentRef,
        paymentToken: requestData.paymentToken,
        paymentMethod: "PayTech",
        paymentType: "appointment",
        status: "completed",
        createdAt: paymentDate,
        structureId: requestData.structureId,
        originalRequestId: requestData.paymentRequestId
      });

      setMessage("Votre demande de rendez-vous a été envoyée avec succès! Paiement confirmé.");

      // Réinitialiser le formulaire
      setRdvFormData({
        date: '',
        heure: '',
        motif: '',
        structureId: '',
        medecinId: '',
        urgent: false
      });
      
      setShowPaymentModal(false);
      setCurrentPaymentRequest(null);
      setPaymentStatus(null);
      
    } catch (error) {
      console.error("Erreur lors de l'envoi de la demande:", error);
      setError("Une erreur s'est produite lors de l'envoi de votre demande.");
    } finally {
      setLoading(false);
    }
  };
  
// Soumettre une demande de rendez-vous - Version modifiée avec affiliation automatique
const handleRdvSubmit = async (e) => {
  e.preventDefault();
  
  if (!rdvFormData.structureId || !rdvFormData.medecinId || !rdvFormData.date || !rdvFormData.heure) {
    setError("Veuillez remplir tous les champs obligatoires");
    return;
  }
  
  // Vérifier si patient existe avant d'accéder à ses propriétés
  if (!patient) {
    setError("Impossible de soumettre la demande: données patient non disponibles");
    return;
  }
  
  try {
    setLoading(true);
    
    // Vérifier si le patient est déjà affilié à la structure sélectionnée
    const isAffiliated = affiliations.some(
      affiliation => affiliation.structureId === rdvFormData.structureId && 
                    (affiliation.statut === 'acceptée' || affiliation.statut === 'en attente')
    );
    
    // Si le patient n'est pas affilié, créer une demande d'affiliation automatique
    if (!isAffiliated) {
      const structureInfo = structures.find(s => s.id === rdvFormData.structureId);
      
      await addDoc(collection(db, 'affiliations'), {
        patientId: auth.currentUser.uid,
        patientNom: `${patient.prenom} ${patient.nom}`,
        structureId: rdvFormData.structureId,
        structureNom: structureInfo?.nom || "Structure médicale",
        motif: `Affiliation automatique suite à une demande de rendez-vous - ${rdvFormData.motif}`,
        statut: 'en attente',
        createdAt: new Date(),
        updatedAt: new Date(),
        isAutomatic: true // Marquer comme affiliation automatique
      });
      
      // Créer une notification pour informer de la demande d'affiliation automatique
      await addDoc(collection(db, "notifications"), {
        userId: auth.currentUser.uid,
        title: "Demande d'affiliation automatique",
        message: `Une demande d'affiliation à ${structureInfo?.nom || "la structure médicale"} a été créée automatiquement avec votre demande de rendez-vous.`,
        type: "affiliation_pending",
        createdAt: new Date(),
        read: false
      });
    }
    
    // Créer la demande de rendez-vous dans Firestore
    const requestRef = await addDoc(collection(db, "rendezvous"), {
      patientId: auth.currentUser.uid,
      patientNom: `${patient.prenom} ${patient.nom}`,
      structureId: rdvFormData.structureId,
      medecinId: rdvFormData.medecinId,
      date: rdvFormData.date,
      heure: rdvFormData.heure,
      motif: rdvFormData.motif,
      urgent: rdvFormData.urgent || false,
      statut: "en attente",
      createdAt: new Date(),
      affiliationStatus: isAffiliated ? "affiliated" : "pending_affiliation"
    });

    // Créer une notification pour le rendez-vous
    await addDoc(collection(db, "notifications"), {
      userId: auth.currentUser.uid,
      title: "Demande de rendez-vous envoyée",
      message: `Votre demande de rendez-vous a été envoyée avec succès.${!isAffiliated ? ' Une demande d\'affiliation a également été créée.' : ''}`,
      type: "request_pending",
      requestId: requestRef.id,
      createdAt: new Date(),
      read: false
    });

    // Message de succès adapté
    if (!isAffiliated) {
      setMessage("Votre demande de rendez-vous a été envoyée avec succès! Une demande d'affiliation a également été créée automatiquement.");
    } else {
      setMessage("Votre demande de rendez-vous a été envoyée avec succès!");
    }

    // Réinitialiser le formulaire
    setRdvFormData({
      date: '',
      heure: '',
      motif: '',
      structureId: '',
      medecinId: '',
      urgent: false
    });
    
  } catch (err) {
    setError("Erreur lors de l'envoi de la demande: " + err.message);
  } finally {
    setLoading(false);
  }
};


  
  // Gérer les changements dans le formulaire d'affiliation
  const handleAffiliationFormChange = (e) => {
    const { name, value } = e.target;
    setAffiliationFormData({
      ...affiliationFormData,
      [name]: value
    });
  };

  // Soumettre une demande d'affiliation directe
  const handleAffiliationSubmit = async (e) => {
    e.preventDefault();
    
    if (!affiliationFormData.structureId) {
      setError("Veuillez sélectionner une structure médicale");
      return;
    }
    
    // Vérifier si patient existe avant d'accéder à ses propriétés
    if (!patient) {
      setError("Impossible de soumettre la demande: données patient non disponibles");
      return;
    }
    
    try {
      // Vérifier si le patient est déjà affilié à la structure
      const isAffiliated = affiliations.some(
        affiliation => affiliation.structureId === affiliationFormData.structureId && affiliation.statut === 'acceptée'
      );
      
      if (isAffiliated) {
        setError("Vous êtes déjà affilié à cette structure médicale");
        return;
      }
      
      // Vérifier si une demande d'affiliation est déjà en cours
      const existingAffiliation = affiliations.find(
        affiliation => affiliation.structureId === affiliationFormData.structureId && 
          affiliation.statut === 'en attente'
      );
      
      if (existingAffiliation) {
        setError("Une demande d'affiliation est déjà en cours pour cette structure");
        return;
      }
      const structureInfo = structures.find(s => s.id === affiliationFormData.structureId);
      
      // Créer la demande d'affiliation
      await addDoc(collection(db, 'affiliations'), {
        patientId: auth.currentUser.uid,
        patientNom: `${patient.prenom} ${patient.nom}`,
        structureId: affiliationFormData.structureId,
        structureNom: structureInfo?.nom || "Structure médicale",
        motif: affiliationFormData.motif,
        statut: 'en attente',
        createdAt: new Date(),
        updatedAt: new Date()
      });
      
      setMessage("Votre demande d'affiliation a été envoyée avec succès");
      
      // Réinitialiser le formulaire
      setAffiliationFormData({
        structureId: '',
        motif: ''
      });
    } catch (err) {
      setError("Erreur lors de l'envoi de la demande d'affiliation: " + err.message);
    }
  };
  
  // Obtenir le nom d'une structure à partir de son ID
  const getStructureName = (structureId) => {
    const structure = structures.find(s => s.id === structureId);
    return structure ? structure.nom : "Structure inconnue";
  };
  
  // Obtenir le nom d'un médecin à partir de son ID
  const getMedecinName = (medecinId) => {
    const medecin = medecins.find(m => m.id === medecinId);
    return medecin ? `Dr. ${medecin.prenom} ${medecin.nom}` : "Médecin inconnu";
  };
  
  // Se déconnecter
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (err) {
      setError("Erreur lors de la déconnexion: " + err.message);
    }
  };
  
  // Formater la date
  const formatDate = (date) => {
    if (!date) return "Date non spécifiée";
    
    if (date instanceof Date) {
      return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
    
    if (date.seconds) {
      return new Date(date.seconds * 1000).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
    
    return date;
  };


  // Get upcoming appointments for messaging component
const getUpcomingAppointments = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Début de la journée
  
  return rendezvous
    .filter(rdv => {
      const rdvDate = new Date(rdv.date);
      return rdvDate >= today && rdv.statut !== 'annulé';
    })
    .map(rdv => {
      const medecin = medecins.find(m => m.id === rdv.medecinId) || {};
      const structure = structures.find(s => s.id === rdv.structureId) || {};
      
      return {
        medecinId: rdv.medecinId,
        medecinNom: medecin.prenom && medecin.nom 
          ? `Dr. ${medecin.prenom} ${medecin.nom}` 
          : "Médecin inconnu",
        date: rdv.date,
        heure: rdv.heure,
        structureId: rdv.structureId,
        structureName: structure.nom || "Structure inconnue"
      };
    });
};


  // Mobile Navigation handling
  const handleMobileNavigation = (tab) => {
    setActiveTab(tab);
    window.scrollTo(0, 0);
  };

  // Mobile Menu Toggle
  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  // Component for Mobile Bottom Navigation similar to Instagram
  const MobileBottomNavigation = () => (
    <div className="mobile-bottom-nav">
      <button
        className={activeTab === 'profil' ? 'active' : ''}
        onClick={() => handleMobileNavigation('profil')}
      >
        <FontAwesomeIcon icon={faUser} />
      </button>
      <button
        className={activeTab === 'rendezvous' ? 'active' : ''}
        onClick={() => handleMobileNavigation('rendezvous')}
      >
        <FontAwesomeIcon icon={faCalendarAlt} />
        {newRendezvousCount > 0 && <span className="mobile-badge">{newRendezvousCount}</span>}
      </button>
      <button
        className={activeTab === 'affiliations' ? 'active' : ''}
        onClick={() => handleMobileNavigation('affiliations')}
      >
        <FontAwesomeIcon icon={faBuilding} />
      </button>
      <button
        className={activeTab === 'nouveauRdv' ? 'active' : ''}
        onClick={() => handleMobileNavigation('nouveauRdv')}
      >
        <FontAwesomeIcon icon={faPlus} className="plus-icon" />
      </button>
      <button
        className={activeTab === 'notifications' ? 'active' : ''}
        onClick={() => handleMobileNavigation('notifications')}
      >
        <FontAwesomeIcon icon={faBell} />
        {unreadNotificationsCount > 0 && <span className="mobile-badge">{unreadNotificationsCount}</span>}
      </button>
      <button
        className={activeTab === 'messagerie' ? 'active' : ''}
        onClick={() => handleMobileNavigation('messagerie')}
      >
        <FontAwesomeIcon icon={faComments} />
        {unreadMessagesCount > 0 && <span className="mobile-badge">{unreadMessagesCount}</span>}
      </button>
    </div>
  );

  // Au début du composant PatientDashboard, ajoutez ces états (après vos autres déclarations d'état)
const [filePreviewModal, setFilePreviewModal] = useState(false);
const [previewFile, setPreviewFile] = useState(null);

// Ajoutez cette fonction dans le composant PatientDashboard (avant le return)
const openFilePreview = (file) => {
  setPreviewFile(file);
  setFilePreviewModal(true);
};

// Ajoutez cette fonction pour fermer le modal
const closeFilePreview = () => {
  setFilePreviewModal(false);
  setPreviewFile(null);
};

// Ajoutez ce composant dans le composant PatientDashboard (avant le return)
const FilePreviewModal = () => (
  <Modal
    show={filePreviewModal}
    onHide={closeFilePreview}
    centered
    size="lg"
    className="file-preview-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title>
        {previewFile?.name || "Aperçu du fichier"}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {previewFile && (
        <div className="file-preview-container">
          {previewFile.type?.startsWith('image/') ? (
            <img src={previewFile.url} alt={previewFile.name} className="img-preview" />
          ) : previewFile.type?.startsWith('application/pdf') ? (
            <iframe 
              src={previewFile.url} 
              title={previewFile.name} 
              width="100%" 
              height="500px"
              className="pdf-preview"
            />
          ) : previewFile.type?.startsWith('video/') ? (
            <video 
              src={previewFile.url} 
              controls 
              className="video-preview" 
            />
          ) : previewFile.type?.startsWith('audio/') ? (
            <audio 
              src={previewFile.url} 
              controls 
              className="audio-preview" 
            />
          ) : (
            <div className="unsupported-file">
              <FontAwesomeIcon icon={faFile} size="3x" />
              <p>Ce type de fichier ne peut pas être prévisualisé</p>
              <Button 
                variant="primary"
                href={previewFile.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faDownload} /> Télécharger le fichier
              </Button>
            </div>
          )}
        </div>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={closeFilePreview}>
        Fermer
      </Button>
      <Button 
        variant="primary" 
        href={previewFile?.url} 
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <FontAwesomeIcon icon={faDownload} /> Télécharger
      </Button>
    </Modal.Footer>
  </Modal>
);

  // Mobile Header Component
  const MobileHeader = () => (
    <div className="mobile-header">
      <div className="mobile-header-title">
        {activeTab === 'profil' && 'Mon Profil'}
        {activeTab === 'rendezvous' && 'Mes Rendez-vous'}
        {activeTab === 'nouveauRdv' && 'Nouveau Rendez-vous'}
        {activeTab === 'messagerie' && 'Messagerie'}
        {activeTab === 'affiliations' && 'Mes Affiliations'}
        {activeTab === 'nouvelleAffiliation' && 'Nouvelle Affiliation'}
        {activeTab === 'securite' && 'Sécurité'}
        {activeTab === 'notifications' && 'Notifications'}
      </div>
      <div className="mobile-header-actions">
        <button 
          className="mobile-header-btn notifications-btn"
          onClick={() => handleMobileNavigation('notifications')}
        >
          <FontAwesomeIcon icon={faBell} />
          {unreadNotificationsCount > 0 && (
            <span className="notification-badge">{unreadNotificationsCount}</span>
          )}
        </button>
        <button 
          className="mobile-header-btn" 
          onClick={toggleMobileMenu}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>
    </div>
  );

    // Mobile Menu Component 
    const MobileMenu = () => (
      <div className={`mobile-menu ${showMobileMenu ? 'visible' : ''}`}>
        <div className="mobile-menu-header">
          <span>Menu</span>
          <button onClick={toggleMobileMenu}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="mobile-menu-content">
          <button onClick={() => {
            handleMobileNavigation('nouvelleAffiliation');
            setShowMobileMenu(false);
          }}>
            <FontAwesomeIcon icon={faBuilding} /> Nouvelle affiliation
          </button>
          <button onClick={() => {
            handleMobileNavigation('securite');
            setShowMobileMenu(false);
          }}>
            <FontAwesomeIcon icon={faShieldAlt} /> Sécurité
          </button>
          <div className="mobile-menu-divider"></div>
          <button onClick={handleLogout} className="mobile-logout-btn">
            <FontAwesomeIcon icon={faTimes} /> Déconnexion
          </button>
        </div>
      </div>
    );
  
  // Composant Modal de paiement avec design épuré
  const PaymentModal = () => (
    <Modal
      show={showPaymentModal}
      onHide={() => setShowPaymentModal(false)}
      centered
      className="payment-modal"
    >
      <Modal.Header className="border-0 pb-0">
        <h4 className="modal-title fw-bold">Paiement</h4>
        <button 
          type="button" 
          className="btn-close shadow-none" 
          onClick={() => setShowPaymentModal(false)}
        ></button>
      </Modal.Header>
      <Modal.Body className="pt-2">
        {paymentStatus && (
          <Alert 
            variant={paymentStatus.success ? "success" : "danger"}
            onClose={() => setPaymentStatus(null)} 
            dismissible
            className="border-0 rounded-3 shadow-sm"
          >
            {paymentStatus.message}
          </Alert>
        )}
        
        <div className="payment-details bg-light p-4 rounded-3 my-3">
          <div className="payment-item d-flex justify-content-between py-2">
            <span className="text-muted">Prise de  rendez-vous</span>
            <span className="amount fw-medium">200 XOF</span>
          </div>
          <div className="payment-item d-flex justify-content-between py-2">
            <span className="text-muted">Frais de dossier</span>
            <span className="amount fw-medium">0 XOF</span>
          </div>
          <div className="payment-divider my-2 border-top"></div>
          <div className="payment-total d-flex justify-content-between py-2">
            <span className="fw-bold">Total à payer</span>
            <span className="total-amount fw-bold text-primary">200 XOF</span>
          </div>
          </div>
        
        <div className="payment-info d-flex align-items-start bg-white p-3 rounded-3 border">
          <i className="bi bi-shield-check text-success fs-4 me-2"></i>
          <p className="mb-0 small text-secondary">
            Le paiement est sécurisé par PayTech. Vous serez redirigé vers une interface sécurisée pour compléter votre transaction.
          </p>
                                    </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button 
          variant="outline-secondary" 
          onClick={() => setShowPaymentModal(false)}
          disabled={isProcessingPayment}
          className="px-4 rounded-pill"
        >
          Annuler
        </Button>
        <Button 
          variant="primary" 
          onClick={() => initiatePayment(currentPaymentRequest)}
          disabled={isProcessingPayment}
          className="px-4 rounded-pill shadow-sm text-secondary"
        >
          {isProcessingPayment ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Traitement...
            </>
          ) : (
            <>Payer maintenant</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
  
  // Composant pour afficher les notifications
  const NotificationsPanel = () => (
    <div className="panel">
      <div className="panel-header">
        <h2>Notifications</h2>
        {unreadNotificationsCount > 0 && (
          <button 
            className="btn btn-link"
            onClick={() => {
              // Marquer toutes les notifications comme lues
              notifications
                .filter(notif => !notif.read)
                .forEach(notif => markNotificationAsRead(notif.id));
            }}
          >
            Tout marquer comme lu
          </button>
        )}
      </div>
      
      <div className="panel-body">
        {notifications.length === 0 ? (
          <div className="empty-state">
            <div className="icon">
              <i className="bi bi-bell-slash"></i>
            </div>
            <h3>Aucune notification</h3>
            <p>Vous n'avez aucune notification pour le moment.</p>
          </div>
        ) : (
          <div className="notifications-list">
            {notifications.map((notification) => (
              <div 
                key={notification.id} 
                className={`notification-item ${!notification.read ? 'unread' : ''}`}
                onClick={() => markNotificationAsRead(notification.id)}
              >
                <div className="notification-icon">
                  {notification.type === 'request_pending' && <i className="bi bi-clock"></i>}
                  {notification.type === 'request_approved' && <i className="bi bi-check-circle"></i>}
                  {notification.type === 'request_rejected' && <i className="bi bi-x-circle"></i>}
                  {notification.type === 'payment_success' && <i className="bi bi-credit-card"></i>}
                  {notification.type === 'new_message' && <i className="bi bi-chat-dots"></i>}
                  {notification.type === 'appointment_reminder' && <i className="bi bi-calendar-event"></i>}
                  {!notification.type && <i className="bi bi-bell"></i>}
                </div>
                
                <div className="notification-content">
                  <h4>{notification.title}</h4>
                  <p>{notification.message}</p>
                  <span className="notification-time">
                    {formatDate(notification.createdAt)}
                  </span>
                </div>
                
                {!notification.read && (
                  <div className="notification-badge"></div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  // 1. Déplacez handleDateClick en dehors du composant CalendarView
  const handleDateClick = (date) => {
    setSelectedDate(parseISO(date));
  };

  // 2. Assurez-vous que generateCalendarDays utilise cette fonction
  const generateCalendarDays = () => {
    // Utiliser des noms courts sur mobile
    const weekdayNames = window.innerWidth <= 767 
      ? ['L', 'M', 'M', 'J', 'V', 'S', 'D'] 
      : ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
    
    // Créer l'en-tête avec les jours de la semaine
    const daysOfWeek = (
      <div className="calendar-days">
        {weekdayNames.map((day) => (
          <div key={day} className="calendar-day-name">{day}</div>
        ))}
      </div>
    );
    
    // Calculer les dates du calendrier
    const monthStart = startOfMonth(currentDate);
    const monthEnd = endOfMonth(monthStart);
    // Commencer par le lundi de la semaine contenant le premier jour du mois
    const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
    // Terminer par le dimanche de la semaine contenant le dernier jour du mois
    const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });
    
    // Tableau pour contenir toutes les cellules de jours
    const days = [];
    let day = startDate;
    
    // Générer toutes les cellules entre la date de début et la date de fin
    while (day <= endDate) {
      const formattedDate = format(day, 'yyyy-MM-dd');
      const isCurrentMonth = isSameMonth(day, monthStart);
      const isToday = isSameDay(day, new Date());
      const isSelected = selectedDate && isSameDay(day, selectedDate);
      
      // Compter les rendez-vous pour ce jour
      const appointmentsForDay = rendezvous.filter(rdv => 
        rdv.date && isSameDay(parseISO(rdv.date), day)
      );
      const count = appointmentsForDay.length;
      
      days.push(
        <div 
          key={formattedDate}
          className={`calendar-cell ${!isCurrentMonth ? 'disabled' : ''} ${isToday ? 'today' : ''} ${isSelected ? 'selected' : ''}`}
          onClick={() => handleDateClick(formattedDate)}
        >
          <span className="calendar-date">{format(day, 'd')}</span>
          {count > 0 && (
            <span className="appointment-count">{count}</span>
          )}
        </div>
      );
      
      // Passer au jour suivant
      day = addDays(day, 1);
    }
    
    // Organiser les jours en semaines (7 jours par ligne)
    const weeks = [];
    const daysPerWeek = 7;
    for (let i = 0; i < days.length; i += daysPerWeek) {
      const weekDays = days.slice(i, i + daysPerWeek);
      
      // S'assurer que chaque semaine a exactement 7 jours
      while (weekDays.length < daysPerWeek) {
        weekDays.push(<div key={`empty-${i}-${weekDays.length}`} className="calendar-cell disabled"></div>);
      }
      
      weeks.push(
        <div key={`week-${i/daysPerWeek}`} className="calendar-row">
          {weekDays}
        </div>
      );
    }
    
    return (
      <>
        {daysOfWeek}
        <div className="calendar-body">
          {weeks}
        </div>
      </>
    );
  };

  // 3. Simplifiez le composant CalendarView
  const CalendarView = () => {
    return (
      <div className="calendar-container">
        <div className="calendar-header">
          <div className="calendar-nav">
            <button onClick={prevMonth}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <span className="current-month">
              {format(currentDate, "MMMM yyyy", { locale: fr })}
            </span>
            <button onClick={nextMonth}>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>
        
        {generateCalendarDays()}
        
        {selectedDate && (
          <div className="selected-date-appointments">
            <h3>Rendez-vous du {format(selectedDate, 'dd MMMM yyyy', { locale: fr })}</h3>
            {selectedDateAppointments.length > 0 ? (
              <div className="appointments-list">
                {selectedDateAppointments.map((rdv) => {
                  const structure = structures.find(s => s.id === rdv.structureId);
                  return (
                    <div key={rdv.id} className={`appointment-mini-card ${rdv.statut === 'confirmé' ? 'confirmed' : rdv.statut === 'annulé' ? 'cancelled' : 'pending'}`}>
                      <div className="appointment-mini-time">{rdv.heure}</div>
                      <div className="appointment-mini-details">
                        <h4>{structure?.nom || "Structure inconnue"}</h4>
                        <p>{getMedecinName(rdv.medecinId)}</p>
                        <div className="appointment-mini-status">
                          <span className="status">{rdv.statut}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="no-appointments">Aucun rendez-vous pour cette date</p>
            )}
          </div>
        )}
      </div>
    );
  };
  
  // Grouper les rendez-vous par date
  useEffect(() => {
    const appointmentsByDateObj = {};
    rendezvous.forEach(rdv => {
      const dateKey = rdv.date;
      if (!appointmentsByDateObj[dateKey]) {
        appointmentsByDateObj[dateKey] = [];
      }
      appointmentsByDateObj[dateKey].push(rdv);
    });
    setAppointmentsByDate(appointmentsByDateObj);
  }, [rendezvous]);
  
  // Naviguer au mois précédent
  const prevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };
  
  // Naviguer au mois suivant
  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };
  

// Charger les conversations du patient
const fetchConversations = async () => {
  try {
    const db = getFirestore();
    const conversationsQuery = query(
      collection(db, 'conversations'),
      where('participants', 'array-contains', auth.currentUser.uid),
      orderBy('lastMessageAt', 'desc')
    );
    
    const unsubscribe = onSnapshot(conversationsQuery, async (snapshot) => {
      const conversationsList = [];
      let totalUnreadCount = 0;
      
      for (const docSnapshot of snapshot.docs) {
        const conversationData = docSnapshot.data();
        // Trouver l'ID de l'autre participant (médecin)
        const otherParticipantId = conversationData.participants.find(
          id => id !== auth.currentUser.uid
        );
        
        // Récupérer les informations du médecin
        if (otherParticipantId) {
          const medecinDocRef = doc(db, 'medecins', otherParticipantId);
          const medecinDocSnapshot = await getDoc(medecinDocRef);
          
          if (medecinDocSnapshot.exists()) {
            const medecinData = medecinDocSnapshot.data();
            const unreadCount = conversationData.unreadBy && 
                conversationData.unreadBy.includes(auth.currentUser.uid) ? 1 : 0;
                
            totalUnreadCount += unreadCount;
            
            conversationsList.push({
              id: docSnapshot.id,
              ...conversationData,
              medecin: {
                id: medecinDocSnapshot.id,
                nom: medecinData.nom,
                prenom: medecinData.prenom,
                specialite: medecinData.specialite,
                photo: medecinData.photo || null
              },
              unreadCount: unreadCount
            });
          }
        }
      }
      
      setUnreadMessagesCount(totalUnreadCount);
      setConversations(conversationsList);
    });
    
    return unsubscribe;
  } catch (err) {
    console.error("Erreur lors du chargement des conversations:", err);
    setError("Impossible de charger vos conversations.");
    return null;
  }
};


// Charger les messages d'une conversation
const fetchMessages = async (conversationId) => {
  if (!conversationId) return;
  
  setLoadingMessages(true);
  try {
    const db = getFirestore();
    const messagesQuery = query(
      collection(db, 'conversations', conversationId, 'messages'),
      orderBy('timestamp', 'asc')
    );
    
    const unsubscribe = onSnapshot(messagesQuery, (snapshot) => {
      const messagesList = snapshot.docs.map(docSnapshot => ({
        id: docSnapshot.id,
        ...docSnapshot.data()
      }));
      
      setMessages(messagesList);
      setLoadingMessages(false);
      
      // Marquer les messages comme lus
      markConversationAsRead(conversationId);
      
      // Scroll to bottom
      setTimeout(() => {
        if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    });
    
    return unsubscribe;
  } catch (err) {
    console.error("Erreur lors du chargement des messages:", err);
    setError("Impossible de charger les messages.");
    setLoadingMessages(false);
    return null;
  }
};


// Envoyer un message
const sendMessage = async (e) => {
  e.preventDefault();
  
  if ((!newMessage.trim() && !attachment) || !selectedConversation || sendingMessage) {
    return;
  }
  
  // Vérifier si patient existe avant d'accéder à ses propriétés
  if (!patient) {
    setError("Impossible d'envoyer le message: données patient non disponibles");
    return;
  }
  
  setSendingMessage(true);
  try {
    const db = getFirestore();
    const messageData = {
      text: newMessage.trim(),
      senderId: auth.currentUser.uid,
      senderName: `${patient.prenom} ${patient.nom}`,
      timestamp: serverTimestamp(),
      read: false
    };
    
    // Si une pièce jointe existe, l'uploader d'abord via Cloudinary
    if (attachment) {
      const formData = new FormData();
      formData.append('file', attachment);
      formData.append('upload_preset', 'fichiers'); // Remplacer par votre upload_preset Cloudinary
      
      // Upload vers Cloudinary
      const cloudinaryResponse = await axios.post(
        `https://api.cloudinary.com/v1_1/dodsr1s0d/upload`, // Remplacer par votre cloud_name
        formData
      );
      
      if (cloudinaryResponse.data && cloudinaryResponse.data.secure_url) {
        // Ajouter l'URL Cloudinary aux données du message
        messageData.attachment = {
          url: cloudinaryResponse.data.secure_url,
          name: attachment.name,
          type: attachment.type,
          public_id: cloudinaryResponse.data.public_id, // Garder l'ID public pour une éventuelle suppression
          cloudinary: true
        };
        
        // Sauvegarder aussi les métadonnées dans Firebase Storage pour la traçabilité
        const storage = getStorage();
        const metadataRef = storageRef(storage, `cloudinary_metadata/${selectedConversation.id}/${Date.now()}_${attachment.name}`);
        
        // Enregistrer seulement les métadonnées
        await setDoc(doc(db, 'cloudinary_files', cloudinaryResponse.data.public_id), {
          url: cloudinaryResponse.data.secure_url,
          public_id: cloudinaryResponse.data.public_id,
          user_id: auth.currentUser.uid,
          conversation_id: selectedConversation.id,
          uploaded_at: serverTimestamp(),
          file_name: attachment.name,
          file_type: attachment.type,
          file_size: cloudinaryResponse.data.bytes
        });
      } else {
        throw new Error("Erreur lors de l'upload vers Cloudinary");
      }
    }
    
    // Ajouter le message à la collection
    await addDoc(collection(db, 'conversations', selectedConversation.id, 'messages'), messageData);
    
    // Mettre à jour la conversation avec le dernier message
    const conversationRef = doc(db, 'conversations', selectedConversation.id);
    await updateDoc(conversationRef, {
      lastMessage: newMessage.trim() || "Pièce jointe",
      lastMessageAt: serverTimestamp(),
      // Marquer comme non lu pour le médecin
      unreadBy: [selectedConversation.medecin.id]
    });
    
    // Réinitialiser les champs
    setNewMessage('');
    setAttachment(null);
    setAttachmentPreview(null);
    
  } catch (err) {
    console.error("Erreur lors de l'envoi du message:", err);
    setError("Impossible d'envoyer votre message.");
  } finally {
    setSendingMessage(false);
  }
};

// Ajouter cette fonction pour la suppression des fichiers
const deleteAttachment = async (attachment) => {
  try {
    if (attachment.cloudinary) {
      // Suppression de Cloudinary
      const deleteResponse = await axios.post(
        `https://api.cloudinary.com/v1_1/dodsr1s0d/image/destroy`,
        {
          public_id: attachment.public_id,
          api_key: '328927441826894',
          api_secret: 'RmG3Hips5ISldmwjaCDKu72L4R4'
        }
      );
      
      // Supprimer également les métadonnées de Firebase
      const db = getFirestore();
      await deleteDoc(doc(db, 'cloudinary_files', attachment.public_id));
      
      return deleteResponse.data.result === 'ok';
    } else {
      // Suppression de Firebase Storage
      const storage = getStorage();
      const fileRef = storageRef(storage, attachment.url);
      await deleteObject(fileRef);
      return true;
    }
  } catch (error) {
    console.error("Erreur lors de la suppression du fichier:", error);
    return false;
  }
};

// Gérer l'upload de fichier
const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  
  // Vérifier la taille du fichier (limite à 5MB)
  if (file.size > 5 * 1024 * 1024) {
    setError("Le fichier est trop volumineux. Taille maximale: 5MB");
    return;
  }
  
  setAttachment(file);
  
  // Créer un aperçu pour les images
  if (file.type.startsWith('image/')) {
    const reader = new FileReader();
    reader.onload = (e) => {
      setAttachmentPreview(e.target.result);
    };
    reader.readAsDataURL(file);
  } else {
    setAttachmentPreview(null);
  }
};

// Annuler l'upload
const cancelAttachment = () => {
  setAttachment(null);
  setAttachmentPreview(null);
};



// Marquer une conversation comme lue
const markConversationAsRead = async (conversationId) => {
  try {
    const db = getFirestore();
    const conversationRef = doc(db, 'conversations', conversationId);
    const conversationSnapshot = await getDoc(conversationRef);
    
    if (conversationSnapshot.exists()) {
      const data = conversationSnapshot.data();
      if (data.unreadBy && data.unreadBy.includes(auth.currentUser.uid)) {
        // Retirer l'ID du patient de unreadBy
        await updateDoc(conversationRef, {
          unreadBy: data.unreadBy.filter(id => id !== auth.currentUser.uid)
        });
        
        // Mettre à jour localement
        setConversations(prevConversations => 
          prevConversations.map(conv => 
            conv.id === conversationId ? {...conv, unreadCount: 0} : conv
          )
        );
      }
    }
  } catch (err) {
    console.error("Erreur lors du marquage de la conversation comme lue:", err);
  }
};



// Créer une nouvelle conversation avec un médecin
const createConversation = async (medecinId, medecinNom, medecinPrenom, medecinSpecialite) => {
  try {
    const db = getFirestore();
    // Vérifier si une conversation existe déjà
    const existingConvQuery = query(
      collection(db, 'conversations'),
      where('participants', '==', [auth.currentUser.uid, medecinId].sort())
    );
    
    const existingConvSnapshot = await getDocs(existingConvQuery);
    
    if (!existingConvSnapshot.empty) {
      // Une conversation existe déjà, la sélectionner
      const existingConvDoc = existingConvSnapshot.docs[0];
      const existingConvData = existingConvDoc.data();
      
      setSelectedConversation({
        id: existingConvDoc.id,
        ...existingConvData,
        medecin: {
          id: medecinId,
          nom: medecinNom,
          prenom: medecinPrenom,
          specialite: medecinSpecialite
        }
      });
      
      // Charger les messages de cette conversation
      fetchMessages(existingConvDoc.id);
      return;
    }
    
    // Créer une nouvelle conversation
    const newConversationRef = await addDoc(collection(db, 'conversations'), {
      participants: [auth.currentUser.uid, medecinId].sort(),
      createdAt: serverTimestamp(),
      lastMessageAt: serverTimestamp(),
      lastMessage: "",
      unreadBy: []
    });
    
    // Sélectionner la nouvelle conversation
    setSelectedConversation({
      id: newConversationRef.id,
      participants: [auth.currentUser.uid, medecinId].sort(),
      medecin: {
        id: medecinId,
        nom: medecinNom,
        prenom: medecinPrenom,
        specialite: medecinSpecialite
      },
      lastMessage: "",
      unreadCount: 0
    });
    
    // Charger les messages (vides pour l'instant)
    fetchMessages(newConversationRef.id);
    
  } catch (err) {
    console.error("Erreur lors de la création de la conversation:", err);
    setError("Impossible de créer une conversation avec ce médecin.");
  }
};

// Initialiser Firestore
useEffect(() => {
  const db = getFirestore();
  // Vous pouvez stocker db dans un état ou une référence si nécessaire
}, []);


// Charger les conversations au chargement
useEffect(() => {
  let unsubscribeFunction = null;
  
  if (auth.currentUser) {
    const loadConversations = async () => {
      unsubscribeFunction = await fetchConversations();
    };
    
    loadConversations();
  }
  
  return () => {
    if (typeof unsubscribeFunction === 'function') {
      unsubscribeFunction();
    }
  };
}, [auth.currentUser]); // Retirer la dépendance à activeTab pour que ça se charge au démarrage


// Charger les messages lorsqu'une conversation est sélectionnée
useEffect(() => {
  let unsubscribeFunction = null;
  
  if (selectedConversation) {
    const loadMessages = async () => {
      unsubscribeFunction = await fetchMessages(selectedConversation.id);
    };
    
    loadMessages();
  }
  
  return () => {
    if (typeof unsubscribeFunction === 'function') {
      unsubscribeFunction();
    }
  };
}, [selectedConversation?.id]);

const specialites = [
  "Généraliste",
  "Cardiologie",
  "Réadaptation Cardiovasculaire",
  "Chirurgie Cardio-Vasculaire",
  "Pneumologie - Spirométrie",
  "Gastro-Entérologie & Endoscopie Digestive",
  "Pédiatrie - Endocrinologie",
  "Nutrition - Nutrithérapie",
  "Diabétologie",
  "Gynécologie",
  "Anesthésie & Réanimation",
  "Dermatologie",
  "Rhumatologie",
  "Cancérologie",
  "Hématologie",
  "Urologie",
  "Orthopédie",
  "Gériatrie",
  "Médecine Physique & Rééducation",
  "Ostéopathie",
  "Laboratoire d'Analyses Médicales",
  "Échographie",
  "Psychiatrie & Addictologie",
  "Psychologie Clinique",
  "Thérapie Capillaire et Cognitivo-Comportementale",
  "Kinésithérapie",
  "Sport de Remise en Forme / Yoga",
  "Ophtalmologie générale",
  "Chirurgie réfractive",
  "Chirurgie de la cataracte",
  "Rétinologie",
  "Glaucome",
  "Ophtalmologie pédiatrique",
  "Neuro-ophtalmologie",
  "Cornée et surface oculaire",
  "Contactologie"
];


  // Rendu principal avec support mobile
  return (
      <div className={`patient-dashboard ${isMobile ? 'mobile-view' : ''}`}>
        {isMobile ? (
          // Mobile Layout (Instagram-like)
          <>
            <MobileHeader />
            
            <div className="mobile-container">
              {/* Notifications */}
              {error && (
                <div className="mobile-notification error">
                  <p>{error}</p>
                  <button className="close-btn" onClick={() => setError('')}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
              )}
              
              {message && (
                <div className="mobile-notification success">
                  <p>{message}</p>
                  <button className="close-btn" onClick={() => setMessage('')}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
              )}
              
              {loading ? (
                <div className="mobile-loader">
                  <div className="spinner-grow" role="status">
                    <span className="visually-hidden">Chargement...</span>
                  </div>
                </div>
              ) : (
                <AnimatePresence mode="wait">
                  <motion.div
                    key={activeTab}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="mobile-content"
                  >
                    {/* Content for different tabs - reusing the same components with mobile-specific styling */}
                    {/* Profil */}
                    {activeTab === 'profil' && (
                      <div className="mobile-panel">
                        {editMode ? (
                          <form onSubmit={handleUpdateProfile} className="mobile-form">
                            <div className="mobile-profile-header">
                              <div className="mobile-avatar">
                                {patient?.prenom?.charAt(0)}{patient?.nom?.charAt(0)}
                              </div>
                              <div className="mobile-profile-actions">
                                <button type="submit" className="mobile-btn mobile-btn-primary">Enregistrer</button>
                                <button type="button" className="mobile-btn mobile-btn-secondary" onClick={() => setEditMode(false)}>Annuler</button>
                              </div>
                            </div>
                            
                            {/* Edit form fields - simplified for mobile */}
                            <div className="mobile-form-group">
                              <label>Nom</label>
                              <input 
                                type="text" 
                                value={formData.nom}
                                onChange={(e) => setFormData({...formData, nom: e.target.value})}
                                required
                              />
                            </div>
                            <div className="mobile-form-group">
                              <label>Prénom</label>
                              <input 
                                type="text" 
                                value={formData.prenom}
                                onChange={(e) => setFormData({...formData, prenom: e.target.value})}
                                required
                              />
                            </div>
                            <div className="mobile-form-group">
                              <label>Téléphone</label>
                              <input 
                                type="tel" 
                                value={formData.telephone}
                                onChange={(e) => setFormData({...formData, telephone: e.target.value})}
                                required
                              />
                            </div>
                            <div className="mobile-form-group">
                              <label>Date de naissance</label>
                              <input 
                                type="date" 
                                value={formData.dateNaissance}
                                onChange={(e) => setFormData({...formData, dateNaissance: e.target.value})}
                                required
                              />
                            </div>
                            <div className="mobile-form-group">
                              <label>Adresse</label>
                              <input 
                                type="text" 
                                value={formData.adresse}
                                onChange={(e) => setFormData({...formData, adresse: e.target.value})}
                                required
                              />
                            </div>
                            <div className="mobile-form-group">
                              <label>Sexe</label>
                              <select 
                                value={formData.sexe}
                                onChange={(e) => setFormData({...formData, sexe: e.target.value})}
                                required
                              >
                                <option value="">Sélectionner</option>
                                <option value="M">Masculin</option>
                                <option value="F">Féminin</option>
                              </select>
                            </div>
                          </form>
                        ) : (
                          <>
                            <div className="mobile-profile-header">
                              <div className="mobile-avatar">
                                {patient?.prenom?.charAt(0)}{patient?.nom?.charAt(0)}
                              </div>
                              <div>
                                <h2>{patient?.prenom} {patient?.nom}</h2>
                                <p className="mobile-email">{patient?.email}</p>
                              </div>
                              <button 
                                className="mobile-edit-btn"
                                onClick={() => setEditMode(true)}
                              >
                                <FontAwesomeIcon icon={faUser} />
                              </button>
                            </div>
                            
                            <div className="mobile-profile-stats">
                              <div className="stat">
                                <span className="count">{rendezvous.length}</span>
                                <span className="label">RDV</span>
                              </div>
                              <div className="stat">
                                <span className="count">{affiliations.filter(a => a.statut === 'acceptée').length}</span>
                                <span className="label">Affiliations</span>
                              </div>
                            </div>
                            
                            <div className="mobile-info-section">
                              <div className="mobile-info-item">
                                <FontAwesomeIcon icon={faPhoneAlt} className="icon" />
                                <div>
                                  <span className="label">Téléphone</span>
                                  <span className="value">{patient?.telephone || '-'}</span>
                                </div>
                              </div>
                              <div className="mobile-info-item">
                                <FontAwesomeIcon icon={faCalendarCheck} className="icon" />
                                <div>
                                  <span className="label">Date de naissance</span>
                                  <span className="value">{patient?.dateNaissance || '-'}</span>
                                </div>
                              </div>
                              <div className="mobile-info-item">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="icon" />
                                <div>
                                  <span className="label">Adresse</span>
                                  <span className="value">{patient?.adresse || '-'}</span>
                                </div>
                              </div>
                              <div className="mobile-info-item">
                                <FontAwesomeIcon icon={faUser} className="icon" />
                                <div>
                                  <span className="label">Sexe</span>
                                  <span className="value">{patient?.sexe === 'M' ? 'Masculin' : patient?.sexe === 'F' ? 'Féminin' : '-'}</span>
                                </div>
                              </div>
                            </div>
                            
                            <div className="mobile-info-section">
                              <h3>Assurances</h3>
                              <div className="mobile-tags">
                                {patient?.assurances?.length > 0 ? (
                                  patient.assurances.map((assurance) => (
                                    <span key={assurance} className="mobile-tag">{assurance}</span>
                                  ))
                                ) : (
                                  <span className="mobile-empty">Aucune assurance enregistrée</span>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                    
                    {/* Mobile rendez-vous */}
                    {activeTab === 'rendezvous' && (
                      <div className="mobile-panel">
                        <div className="mobile-calendar-toggle">
                          <button 
                            className={!calendarView ? 'active' : ''} 
                            onClick={() => setCalendarView(false)}
                          >
                            <FontAwesomeIcon icon={faList} /> Liste
                          </button>
                          <button 
                            className={calendarView ? 'active' : ''} 
                            onClick={() => setCalendarView(true)}
                          >
                            <FontAwesomeIcon icon={faCalendarAlt} /> Calendrier
                          </button>
                        </div>
                        
                        {rendezvous.length === 0 ? (
                          <div className="mobile-empty-state">
                            <FontAwesomeIcon icon={faCalendarAlt} size="3x" />
                            <h3>Aucun rendez-vous</h3>
                            <button 
                              className="mobile-btn mobile-btn-primary"
                              onClick={() => setActiveTab('nouveauRdv')}
                            >
                              Prendre un rendez-vous
                            </button>
                          </div>
                        ) : calendarView ? (
                          <CalendarView />
                        ) : (
                          <div className="mobile-appointments">
                            {rendezvous.map((rdv) => {
                              const structure = structures.find(s => s.id === rdv.structureId);
                              return (
                                <div key={rdv.id} className={`mobile-appointment-card ${rdv.statut === 'confirmé' ? 'confirmed' : rdv.statut === 'annulé' ? 'cancelled' : 'pending'}`}>
                                  <div className="mobile-appointment-date">
                                    <div className="day">{rdv.date.split('-')[2]}</div>
                                    <div className="month">{new Date(rdv.date).toLocaleString('fr-FR', {month: 'short'})}</div>
                                  </div>
                                  
                                  <div className="mobile-appointment-details">
                                    <h4>{structure?.nom || "Structure inconnue"}</h4>
                                    <p>
                                      <FontAwesomeIcon icon={faClock} /> {rdv.heure}
                                    </p>
                                    <p>
                                      <FontAwesomeIcon icon={faUserMd} /> {getMedecinName(rdv.medecinId)}
                                    </p>
                                    <div className="mobile-appointment-status">
                                      <span className="status">{rdv.statut}</span>
                                      <span className="payment-status">
                                        {rdv.paymentStatus === 'completed' ? 'Payé' : 'Non payé'}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                    
                    {/* Nouveau rendez-vous - simplified for mobile */}
                    {activeTab === 'nouveauRdv' && (
                      <div className="mobile-panel">
                        <form onSubmit={handleRdvSubmit} className="mobile-form">
                          <div className="mobile-form-group">
                            <label>Structure médicale ou Service privé</label>
                            <div className="mobile-search-input">
                              <FontAwesomeIcon icon={faSearch} />
                              <input
                                type="text"
                                placeholder="Rechercher une structure..."
                                value={structureSearchTerm}
                                onChange={(e) => setStructureSearchTerm(e.target.value)}
                              />
                            </div>
                            <select 
                              name="structureId"
                              value={rdvFormData.structureId}
                              onChange={handleStructureChange}
                              required
                            >
                              <option value="">Sélectionner une structure</option>
                              {structures
                                .filter(structure => 
                                  structure.nom && structure.nom.toLowerCase().includes(structureSearchTerm.toLowerCase())
                                )
                                .map((structure) => (
                                  <option key={structure.id} value={structure.id}>
                                    {structure.nom}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                          
                          {rdvFormData.structureId && (
                            <div className="mobile-form-group">
                              <label>Médecin</label>
                              {filteredMedecins.length > 0 ? (
                                <select 
                                  name="medecinId"
                                  value={rdvFormData.medecinId}
                                  onChange={handleMedecinChange}
                                  required
                                >
                                  <option value="">Sélectionner un médecin</option>
                                  {filteredMedecins.map((medecin) => (
                                    <option key={medecin.id} value={medecin.id}>
                                      Dr. {medecin.prenom} {medecin.nom} - {medecin.specialite}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <div className="mobile-info-message">
                                  Aucun médecin disponible pour cette structure.
                                </div>
                              )}
                            </div>
                          )}
                          
                          <div className="mobile-form-group">
                            <label>Date</label>
                            <input 
                              type="date" 
                              name="date"
                              value={rdvFormData.date}
                              onChange={handleRdvFormChange}
                              min={new Date().toISOString().split('T')[0]}
                              required
                            />
                          </div>
                          
                          <div className="mobile-form-group">
                            <label>Heure</label>
                            <input 
                              type="time" 
                              name="heure"
                              value={rdvFormData.heure}
                              onChange={handleRdvFormChange}
                              required
                            />
                          </div>
                          
                          <div className="mobile-form-group">
                            <label>Motif de la consultation</label>
                            <textarea 
                              name="motif"
                              value={rdvFormData.motif}
                              onChange={handleRdvFormChange}
                              rows="3"
                              placeholder="Décrivez brièvement le motif de votre consultation..."
                              required
                            ></textarea>
                          </div>
                          
                         
                          
                         
                          
                          <button type="submit" className="mobile-btn mobile-btn-primary">
                            Demander un rendez-vous
                          </button>
                        </form>
                      </div>
                    )}
                    
                    
                    
                    {/* Affiliations - simplified for mobile */}
                    {activeTab === 'affiliations' && (
                      <div className="mobile-panel">
                        {affiliations.length === 0 ? (
                          <div className="mobile-empty-state">
                            <FontAwesomeIcon icon={faBuilding} size="3x" />
                            <h3>Aucune affiliation</h3>
                            <button 
                              className="mobile-btn mobile-btn-primary"
                              onClick={() => setActiveTab('nouvelleAffiliation')}
                            >
                              Demander une affiliation
                            </button>
                          </div>
                        ) : (
                          <div className="mobile-affiliations">
                            {affiliations.map((affiliation) => (
                              <div key={affiliation.id} className={`mobile-affiliation-card ${affiliation.statut === 'acceptée' ? 'accepted' : affiliation.statut === 'refusée' ? 'rejected' : 'pending'}`}>
                                <div className="mobile-affiliation-header">
                                  <FontAwesomeIcon icon={faBuilding} className="icon" />
                                  <h4>{affiliation.structureNom}</h4>
                                </div>
                                <div className="mobile-affiliation-details">
                                  <p>
                                    <FontAwesomeIcon icon={faCalendarCheck} /> Demande: {formatDate(affiliation.createdAt)}
                                  </p>
                                  <div className="mobile-affiliation-status">
                                    <span className="status">{affiliation.statut}</span>
                                    
                                    {affiliation.statut === 'acceptée' && (
                                      <button 
                                        className="mobile-btn mobile-btn-sm"
                                        onClick={() => {
                                          setRdvFormData({...rdvFormData, structureId: affiliation.structureId});
                                          setActiveTab('nouveauRdv');
                                        }}
                                      >
                                        Prendre RDV
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                    
                    {/* Nouvelle affiliation */}
                    {activeTab === 'nouvelleAffiliation' && (
                      <div className="mobile-panel">
                        <form onSubmit={handleAffiliationSubmit} className="mobile-form">
                          <div className="mobile-form-group">
                            <label>Structure médicale</label>
                            <div className="mobile-search-input">
                              <FontAwesomeIcon icon={faSearch} />
                              <input
                                type="text"
                                placeholder="Rechercher une structure..."
                                value={structureSearchTerm}
                                onChange={(e) => setStructureSearchTerm(e.target.value)}
                              />
                            </div>
                            <select 
                              name="structureId"
                              value={affiliationFormData.structureId}
                              onChange={handleAffiliationFormChange}
                              required
                            >
                              <option value="">Sélectionner une structure</option>
                              {structures
                                .filter(structure => 
                                  structure.nom && structure.nom.toLowerCase().includes(structureSearchTerm.toLowerCase())
                                )
                                .map((structure) => (
                                  <option key={structure.id} value={structure.id}>
                                    {structure.nom}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                          
                          <div className="mobile-form-group">
                            <label>Motif de la demande</label>
                            <textarea 
                              name="motif"
                              value={affiliationFormData.motif}
                              onChange={handleAffiliationFormChange}
                              rows="3"
                              placeholder="Expliquez pourquoi vous souhaitez vous affilier à cette structure médicale..."
                              required
                            ></textarea>
                          </div>
                          
                          <button type="submit" className="mobile-btn mobile-btn-primary">
                            Demander une affiliation
                          </button>
                        </form>
                      </div>
                    )}
                    
                    {/* Messagerie - Mobile view */}
{activeTab === 'messagerie' && (
  <div className="mobile-panel">
    {selectedConversation ? (
      // Vue conversation mobile
      <div className="mobile-chat-view">
        <div className="mobile-chat-header">
          <button 
            className="back-button" 
            onClick={() => setSelectedConversation(null)}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          
          <div className="mobile-chat-user">
            <div className="mobile-chat-avatar">
              {selectedConversation.medecin.photo ? (
                <img src={selectedConversation.medecin.photo} alt={`Dr. ${selectedConversation.medecin.prenom}`} />
              ) : (
                <span>{selectedConversation.medecin.prenom[0]}{selectedConversation.medecin.nom[0]}</span>
              )}
            </div>
            <div>
              <h4>Dr. {selectedConversation.medecin.prenom} {selectedConversation.medecin.nom}</h4>
              <p>{selectedConversation.medecin.specialite}</p>
            </div>
          </div>
        </div>
        
        <div className="mobile-messages-container">
          {loadingMessages ? (
            <div className="mobile-loading-messages">
              <div className="spinner-border spinner-border-sm" role="status"></div>
              <p>Chargement...</p>
            </div>
          ) : messages.length === 0 ? (
            <div className="mobile-no-messages">
              <FontAwesomeIcon icon={faComments} size="2x" />
              <p>Aucun message. Commencez la conversation!</p>
            </div>
          ) : (
            <div className="mobile-messages-list">
              {messages.map((message) => {
                const isOwn = message.senderId === auth.currentUser.uid;
                return (
                  <div 
                    key={message.id} 
                    className={`mobile-message-item ${isOwn ? 'own' : 'other'}`}
                  >
                    {!isOwn && (
                      <div className="mobile-message-avatar">
                        {selectedConversation.medecin.photo ? (
                          <img src={selectedConversation.medecin.photo} alt="Dr." />
                        ) : (
                          <span>{selectedConversation.medecin.prenom[0]}{selectedConversation.medecin.nom[0]}</span>
                        )}
                      </div>
                    )}
                    
                    <div className="mobile-message-bubble">
                      {message.text && (
                        <div className="mobile-message-text">{message.text}</div>
                      )}
                      
                      {message.attachment && (
                        <div className="mobile-message-attachment">
                          {message.attachment.type.startsWith('image/') ? (
                            <div 
                              className="mobile-attachment-thumbnail" 
                              onClick={() => openFilePreview(message.attachment)}
                            >
                              <img src={message.attachment.url} alt="Pièce jointe" />
                            </div>
                          ) : (
                            <div 
                              className="mobile-file-attachment"
                              onClick={() => openFilePreview(message.attachment)}
                            >
                              <FontAwesomeIcon icon={faFile} />
                              <span>{message.attachment.name}</span>
                              <FontAwesomeIcon icon={faEye} />
                            </div>
                          )}
                        </div>
                      )}
                      
                      <div className="mobile-message-time">
                        {message.timestamp ? new Date(message.timestamp.toDate()).toLocaleTimeString('fr-FR', {
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : 'Envoi...'}
                      </div>
                    </div>
                  </div>
                );
              })}
              <div ref={messagesEndRef} />
            </div>
          )}
        </div>
        
        <form className="mobile-message-form" onSubmit={sendMessage}>
          {attachmentPreview && (
            <div className="mobile-attachment-preview">
              {attachment.type.startsWith('image/') ? (
                <img src={attachmentPreview} alt="Aperçu" />
              ) : (
                <div className="mobile-file-preview">
                  <FontAwesomeIcon icon={faFile} />
                  <span>{attachment.name}</span>
                </div>
              )}
              <button type="button" className="mobile-cancel-attachment" onClick={cancelAttachment}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          )}
          
          <div className="mobile-message-input-container">
            <button type="button" className="mobile-attach-button">
              <label htmlFor="mobile-file-upload">
                <FontAwesomeIcon icon={faPaperclip} />
                <input 
                  id="mobile-file-upload" 
                  type="file" 
                  onChange={handleFileChange} 
                  style={{ display: 'none' }}
                  accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
              </label>
            </button>
            
            <input 
              type="text" 
              placeholder="Message..." 
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              disabled={sendingMessage}
            />
            
            <button 
              type="submit" 
              className="mobile-send-button"
              disabled={(!newMessage.trim() && !attachment) || sendingMessage}
            >
              {sendingMessage ? (
                <FontAwesomeIcon icon={faCircleNotch} spin />
              ) : (
                <FontAwesomeIcon icon={faPaperPlane} />
              )}
            </button>
          </div>
        </form>
      </div>
    ) : (
      // Liste des conversations mobile
      <>
        <div className="mobile-conversations-header">
          <h3>Messagerie</h3>
        </div>
        
        {conversations.length === 0 ? (
          <div className="mobile-empty-state">
            <FontAwesomeIcon icon={faComments} size="3x" />
            <h3>Aucune conversation</h3>
            <p>Vos conversations avec les médecins apparaîtront ici.</p>
          </div>
        ) : (
          <div className="mobile-conversations-list">
            {conversations.map(conversation => (
              <div 
                key={conversation.id} 
                className={`mobile-conversation-item ${conversation.unreadCount > 0 ? 'unread' : ''}`}
                onClick={() => setSelectedConversation(conversation)}
              >
                <div className="mobile-conversation-avatar">
                  {conversation.medecin.photo ? (
                    <img src={conversation.medecin.photo} alt={`Dr. ${conversation.medecin.prenom}`} />
                  ) : (
                    <span>{conversation.medecin.prenom[0]}{conversation.medecin.nom[0]}</span>
                  )}
                </div>
                <div className="mobile-conversation-info">
                  <h4>Dr. {conversation.medecin.prenom} {conversation.medecin.nom}</h4>
                  <p className="mobile-speciality">{conversation.medecin.specialite}</p>
                  <p className="mobile-last-message">{conversation.lastMessage || "Nouvelle conversation"}</p>
                </div>
                {conversation.unreadCount > 0 && (
                  <div className="mobile-unread-badge">{conversation.unreadCount}</div>
                )}
              </div>
            ))}
          </div>
        )}
        
        <div className="mobile-section-header">
          <h3>Prochains rendez-vous</h3>
        </div>
        
        {getUpcomingAppointments().length === 0 ? (
          <div className="mobile-info-message">
            <p>Aucun rendez-vous à venir</p>
          </div>
        ) : (
          <div className="mobile-upcoming-appointments">
            {getUpcomingAppointments().map((appointment, index) => (
              <div key={index} className="mobile-appointment-chat-item">
                <div className="mobile-appointment-chat-info">
                  <h4>Dr. {appointment.medecinNom}</h4>
                  <p>{appointment.date} à {appointment.heure}</p>
                  <p className="mobile-structure-name">{appointment.structureName}</p>
                </div>
                <button 
                  className="mobile-chat-btn"
                  onClick={() => createConversation(
                    appointment.medecinId,
                    appointment.medecinNom.split(' ')[1], // Nom
                    appointment.medecinNom.split(' ')[0].replace('Dr. ', ''), // Prénom
                    "Médecin"
                  )}
                >
                  <FontAwesomeIcon icon={faComments} />
                </button>
              </div>
            ))}
          </div>
        )}
      </>
    )}
  </div>
)}




                    {/* Sécurité - simplified for mobile */}
                    {activeTab === 'securite' && (
                      <div className="mobile-panel">
                        <form onSubmit={handleChangePassword} className="mobile-form">
                          <div className="mobile-info-message warning">
                            <h4>Conseils de sécurité</h4>
                            <p>
                              Utilisez un mot de passe fort contenant au moins 8 caractères.
                            </p>
                          </div>
                          
                          <div className="mobile-form-group">
                            <label>Nouveau mot de passe</label>
                            <input 
                              type="password" 
                              value={passwordData.newPassword}
                              onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})}
                              required
                              minLength="8"
                            />
                          </div>
                          
                          <div className="mobile-form-group">
                            <label>Confirmer le mot de passe</label>
                            <input 
                              type="password" 
                              value={passwordData.confirmPassword}
                              onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})}
                              required
                              minLength="8"
                            />
                          </div>
                          
                          <button type="submit" className="mobile-btn mobile-btn-primary">
                            Changer le mot de passe
                          </button>
                        </form>
                      </div>
                    )}
                    
                    {/* Notifications - Mobile view */}
                    {activeTab === 'notifications' && (
                      <div className="mobile-panel">
                        <div className="mobile-notifications-header">
                          {unreadNotificationsCount > 0 && (
                            <button 
                              className="mobile-btn mobile-btn-sm mobile-btn-link"
                              onClick={() => {
                                // Marquer toutes les notifications comme lues
                                notifications
                                  .filter(notif => !notif.read)
                                  .forEach(notif => markNotificationAsRead(notif.id));
                              }}
                            >
                              Tout marquer comme lu
                            </button>
                          )}
                        </div>
                        
                        {notifications.length === 0 ? (
                          <div className="mobile-empty-state">
                            <FontAwesomeIcon icon={faBell} size="3x" />
                            <h3>Aucune notification</h3>
                            <p>Vous n'avez aucune notification pour le moment.</p>
                          </div>
                        ) : (
                          <div className="mobile-notifications-list">
                            {notifications.map((notification) => (
                              <div 
                                key={notification.id} 
                                className={`mobile-notification-item ${!notification.read ? 'unread' : ''}`}
                                onClick={() => markNotificationAsRead(notification.id)}
                              >
                                <div className="mobile-notification-icon">
                                  {notification.type === 'request_pending' && <FontAwesomeIcon icon={faClock} />}
                                  {notification.type === 'request_approved' && <FontAwesomeIcon icon={faCheck} />}
                                  {notification.type === 'request_rejected' && <FontAwesomeIcon icon={faTimes} />}
                                  {notification.type === 'payment_success' && <FontAwesomeIcon icon={faCheck} />}
                                  {notification.type === 'new_message' && <FontAwesomeIcon icon={faComments} />}
                                  {notification.type === 'appointment_reminder' && <FontAwesomeIcon icon={faCalendarAlt} />}
                                  {!notification.type && <FontAwesomeIcon icon={faBell} />}
                                </div>
                                
                                <div className="mobile-notification-content">
                                  <h4>{notification.title}</h4>
                                  <p>{notification.message}</p>
                                  <span className="mobile-notification-time">
                                    {formatDate(notification.createdAt)}
                                  </span>
                                </div>
                                
                                {!notification.read && (
                                  <div className="mobile-notification-indicator"></div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </motion.div>
                </AnimatePresence>
               )}
            </div>
            
            {/* Mobile bottom navigation */}
            <MobileBottomNavigation />
            {/* Mobile menu */}
            {showMobileMenu && <MobileMenu />}
          </>
        ) : (
          // Desktop Layout
          <>
      {/* Header simplifié */}
      <header className="dashboard-header">
      <div className="dashboard-logo">CABINET D'OPHTALMOLOGIE </div>
        
        <div className="user-menu">
         
          <button className="btn-logout" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right">Déconnexion</i>
          </button>
        </div>
      </header>
      
      {/* Contenu principal */}
      <div className="main-container">
        {loading ? (
          <div className="loader">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
            <p>Chargement...</p>
          </div>
        ) : (
          <div className="dashboard-layout">
            {/* Sidebar minimaliste */}
            <aside className="dashboard-sidebar">
              <nav className="nav-menu">
                <ul>
                  <li className={activeTab === 'profil' ? 'active' : ''}>
                    <button onClick={() => setActiveTab('profil')}>
                      <FontAwesomeIcon icon={faUser} />
                      <span>Profil</span>
                    </button>
                  </li>
                  <li className={activeTab === 'rendezvous' ? 'active' : ''}>
                    <button onClick={() => setActiveTab('rendezvous')}>
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      <span>Rendez-vous</span>
                      {newRendezvousCount > 0 && <span className="badge">{newRendezvousCount}</span>}
                    </button>
                  </li>
                  <li className={activeTab === 'nouveauRdv' ? 'active' : ''}>
                    <button onClick={() => setActiveTab('nouveauRdv')}>
                      <i className="bi bi-plus-circle"></i>
                      <span>Nouveau RDV</span>
                    </button>
                  </li>
                  <li className={activeTab === 'messagerie' ? 'active' : ''}>
                    <button onClick={() => setActiveTab('messagerie')}>
                      <i className="bi bi-chat"></i>
                      <span>Messagerie</span>
                      {unreadMessagesCount > 0 && <span className="badge">{unreadMessagesCount}</span>}
                    </button>
                  </li>
                  <li className={activeTab === 'notifications' ? 'active' : ''}>
                    <button onClick={() => setActiveTab('notifications')}>
                      <i className="bi bi-bell"></i>
                      <span>Notifications</span>
                      {unreadNotificationsCount > 0 && <span className="badge">{unreadNotificationsCount}</span>}
                    </button>
                  </li>
                  <li className={activeTab === 'affiliations' ? 'active' : ''}>
                    <button onClick={() => setActiveTab('affiliations')}>
                      <i className="bi bi-building"></i>
                      <span>Affiliations</span>
                      {newAffiliationsCount > 0 && <span className="badge">{newAffiliationsCount}</span>}
                    </button>
                  </li>
                  <li className={activeTab === 'nouvelleAffiliation' ? 'active' : ''}>
                    <button onClick={() => setActiveTab('nouvelleAffiliation')}>
                      <i className="bi bi-plus-square"></i>
                      <span>Nouvelle affiliation</span>
                    </button>
                  </li>
                  <li className={activeTab === 'securite' ? 'active' : ''}>
                    <button onClick={() => setActiveTab('securite')}>
                      <i className="bi bi-shield-lock"></i>
                      <span>Sécurité</span>
                    </button>
                  </li>
                </ul>
              </nav>
            </aside>
            
            {/* Contenu principal */}
            <main className="dashboard-content">
              {/* Notifications */}
              {error && (
                <div className="notification error">
                  <p>{error}</p>
                  <button className="close-btn" onClick={() => setError('')}>
                    <i className="bi bi-x"></i>
                  </button>
                </div>
              )}
              
              {message && (
                <div className="notification success">
                  <p>{message}</p>
                  <button className="close-btn" onClick={() => setMessage('')}>
                    <i className="bi bi-x"></i>
                  </button>
                </div>
              )}
              
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  className="tab-content"
                >
                  {/* Profil */}
                  {activeTab === 'profil' && (
                    <div className="panel">
                      <div className="panel-header">
                        <h2>Mon profil</h2>
                        <button 
                          className={`btn ${editMode ? 'btn-cancel' : 'btn-edit'}`}
                          onClick={() => setEditMode(!editMode)}
                        >
                          {editMode ? 'Annuler' : 'Modifier'}
                        </button>
                      </div>
                      
                      <div className="panel-body">
                        {editMode ? (
                          <form onSubmit={handleUpdateProfile} className="form">
                            <div className="form-grid">
                              <div className="form-group">
                                <label>Nom</label>
                                <input 
                                  type="text" 
                                  value={formData.nom}
                                  onChange={(e) => setFormData({...formData, nom: e.target.value})}
                                  required
                                />
                              </div>
                              <div className="form-group">
                                <label>Prénom</label>
                                <input 
                                  type="text" 
                                  value={formData.prenom}
                                  onChange={(e) => setFormData({...formData, prenom: e.target.value})}
                                  required
                                />
                              </div>
                              <div className="form-group">
                                <label>Email</label>
                                <input 
                                  type="email" 
                                  value={formData.email}
                                  disabled
                                  className="disabled"
                                />
                                <small>L'email ne peut pas être modifié</small>
                              </div>
                              <div className="form-group">
                                <label>Téléphone</label>
                                <input 
                                  type="tel" 
                                  value={formData.telephone}
                                  onChange={(e) => setFormData({...formData, telephone: e.target.value})}
                                  required
                                />
                              </div>
                              <div className="form-group">
                                <label>Date de naissance</label>
                                <input 
                                  type="date" 
                                  value={formData.dateNaissance}
                                  onChange={(e) => setFormData({...formData, dateNaissance: e.target.value})}
                                  required
                                />
                              </div>
                              <div className="form-group">
                                <label>Sexe</label>
                                <select 
                                  value={formData.sexe}
                                  onChange={(e) => setFormData({...formData, sexe: e.target.value})}
                                  required
                                >
                                  <option value="">Sélectionner</option>
                                  <option value="M">Masculin</option>
                                  <option value="F">Féminin</option>
                                </select>
                              </div>
                            </div>
                            
                            <div className="form-group">
                              <label>Adresse</label>
                              <input 
                                type="text" 
                                value={formData.adresse}
                                onChange={(e) => setFormData({...formData, adresse: e.target.value})}
                                required
                              />
                            </div>
                            
                            <div className="form-group">
                              <label>Numéro d'assurance</label>
                              <input 
                                type="text" 
                                value={formData.numeroAssurance}
                                onChange={(e) => setFormData({...formData, numeroAssurance: e.target.value})}
                              />
                            </div>
                            
                            <div className="form-group">
                              <label>Assurances</label>
                              <div className="checkbox-group">
                                {["CNAM", "CNSS", "CNRPS", "Assurance privée", 
                                      "Sanlam", "AXA", "NSIA", "Saham Assurance", "Leadway Assurance",
                                      "Mutuelle des Fonctionnaires", "SONAM", "Allianz", "Liberty Mutual",
                                      "Activa Assurance", "SUNU Assurances", "GA Insurance", "MUA Insurance",
                                      "Fidelity Insurance", "Old Mutual", "Hollard Insurance", "Ecobank Assurances",
                                      "Prudential", "Afric Assistance", "ASKIA Assurances", "BICIS Assurances",
                                      "UGB Assurance", "AMO Assurance"
                                    ].map((assurance) => (
                                  <label key={assurance} className="checkbox-label">
                                    <input 
                                      type="checkbox" 
                                      checked={formData.assurances.includes(assurance)}
                                      onChange={() => handleAssuranceChange(assurance)}
                                    />
                                    <span>{assurance}</span>
                                  </label>
                                ))}
                              </div>
                            </div>
                            
                            <div className="form-group">
                              <label>Antécédents médicaux</label>
                              <textarea 
                                rows="4"
                                value={formData.antecedentsMedicaux}
                                onChange={(e) => setFormData({...formData, antecedentsMedicaux: e.target.value})}
                              ></textarea>
                            </div>
                            
                            <button type="submit" className="btn btn-submit">
                              Enregistrer
                            </button>
                          </form>
                        ) : (
                          <div className="profile-info">
                            <div className="profile-header">
                              <div className="avatar">
                                {patient?.prenom?.charAt(0)}{patient?.nom?.charAt(0)}
                              </div>
                              <div>
                                <h3>{patient?.prenom} {patient?.nom}</h3>
                                <p>{patient?.email}</p>
                              </div>
                            </div>
                            
                            <div className="info-grid">
                              <div className="info-item">
                                <span className="label">Téléphone</span>
                                <span className="value">{patient?.telephone || '-'}</span>
                              </div>
                              <div className="info-item">
                                <span className="label">Date de naissance</span>
                                <span className="value">{patient?.dateNaissance || '-'}</span>
                              </div>
                              <div className="info-item">
                                <span className="label">Sexe</span>
                                <span className="value">{patient?.sexe === 'M' ? 'Masculin' : patient?.sexe === 'F' ? 'Féminin' : '-'}</span>
                              </div>
                              <div className="info-item">
                                <span className="label">Adresse</span>
                                <span className="value">{patient?.adresse || '-'}</span>
                              </div>
                              <div className="info-item">
                                <span className="label">Numéro d'assurance</span>
                                <span className="value">{patient?.numeroAssurance || '-'}</span>
                              </div>
                            </div>
                            
                            <div className="info-section">
                              <h4>Assurances</h4>
                              <div className="tags">
                                {patient?.assurances?.length > 0 ? (
                                  patient.assurances.map((assurance) => (
                                    <span key={assurance} className="tag">{assurance}</span>
                                  ))
                                ) : (
                                  <span className="empty">Aucune assurance enregistrée</span>
                                )}
                              </div>
                            </div>
                            
                            <div className="info-section">
                              <h4>Antécédents médicaux</h4>
                              <div className="medical-history">
                                <p>{patient?.antecedentsMedicaux || 'Aucun antécédent médical enregistré'}</p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  {/* Rendez-vous */}
                  {activeTab === 'rendezvous' && (
                    <div className="panel">
                      <div className="panel-header">
                        <h2>Mes rendez-vous</h2>
                        <div className="view-toggle">
                          <button 
                            className={`view-btn ${!calendarView ? 'active' : ''}`} 
                            onClick={() => setCalendarView(false)}
                          >
                            <FontAwesomeIcon icon={faList} />
                          </button>
                          <button 
                            className={`view-btn ${calendarView ? 'active' : ''}`} 
                            onClick={() => setCalendarView(true)}
                          >
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </button>
                        </div>
                      </div>
                      
                      <div className="panel-body">
                        {rendezvous.length === 0 ? (
                          <div className="empty-state">
                            <div className="icon">
                              <i className="bi bi-calendar-x"></i>
                            </div>
                            <h3>Vous n'avez pas encore de rendez-vous</h3>
                            <button 
                              className="btn btn-action"
                              onClick={() => setActiveTab('nouveauRdv')}
                            >
                              Prendre un rendez-vous
                            </button>
                          </div>
                        ) : calendarView ? (
                          <CalendarView />
                        ) : (
                          <div className="appointments">
                            {rendezvous.map((rdv) => {
                              const structure = structures.find(s => s.id === rdv.structureId);
                              return (
                                <div key={rdv.id} className={`appointment-card ${rdv.statut === 'confirmé' ? 'confirmed' : rdv.statut === 'annulé' ? 'cancelled' : 'pending'}`}>
                                  <div className="ms-card-highlight" style={{backgroundColor: rdv.statut === 'confirmé' ? '#107c10' : rdv.statut === 'annulé' ? '#d83b01' : '#0078d7'}}></div>
                                  <div className="appointment-date">
                                    <div className="day">{rdv.date.split('-')[2]}</div>
                                    <div className="month">{new Date(rdv.date).toLocaleString('fr-FR', {month: 'short'})}</div>
                                  </div>
                                  <div className="appointment-details">
                                    <h4>{structure?.nom || "Structure inconnue"}</h4>
                                    <p>
                                      <FontAwesomeIcon icon={faClock} /> {rdv.heure}
                                    </p>
                                    <p>
                                      <FontAwesomeIcon icon={faUserMd} /> {getMedecinName(rdv.medecinId)}
                                    </p>
                                    <div className="appointment-status">
                                      <span className="status">{rdv.statut}</span>
                                      <span className="payment-status">
                                        {rdv.paymentStatus === 'completed' ? 'Payé' : 'Non payé'}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  {/* Nouveau rendez-vous */}
                  {activeTab === 'nouveauRdv' && (
                    <div className="panel">
                      <div className="panel-header">
                        <h2>Nouveau rendez-vous</h2>
                      </div>
                      
                      <div className="panel-body">
                        <form onSubmit={handleRdvSubmit} className="form">
                          <div className="form-group">
                            <label>Structure médicale</label>
                            <div className="search-input">
                              <i className="bi bi-search"></i>
                              <input
                                type="text"
                                placeholder="Rechercher une structure..."
                                value={structureSearchTerm}
                                onChange={(e) => setStructureSearchTerm(e.target.value)}
                              />
                            </div>
                            <select 
                              name="structureId"
                              value={rdvFormData.structureId}
                              onChange={handleStructureChange}
                              required
                            >
                              <option value="">Sélectionner une structure</option>
                              {structures
                                .filter(structure => 
                                  structure.nom && structure.nom.toLowerCase().includes(structureSearchTerm.toLowerCase())
                                )
                                .map((structure) => (
                                  <option key={structure.id} value={structure.id}>
                                    {structure.nom}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                          
                          {rdvFormData.structureId && (
                            <div className="form-group">
                              <label>Médecin</label>
                             

                              <div className="filter-buttons">
  <button 
    type="button" 
    className={`filter-btn ${selectedSpeciality === '' ? 'active' : ''}`}
    onClick={() => handleSpecialiteFilter('')}
  >
    Tous
  </button>
  {specialites.map(specialite => (
    <button 
      key={specialite}
      type="button" 
      className={`filter-btn ${selectedSpeciality === specialite ? 'active' : ''}`}
      onClick={() => handleSpecialiteFilter(specialite)}
    >
      {specialite}
    </button>
  ))}
</div>
                              {filteredMedecins.length > 0 ? (
                                <select 
                                  name="medecinId"
                                  value={rdvFormData.medecinId}
                                  onChange={handleMedecinChange}
                                  required
                                >
                                  <option value="">Sélectionner un médecin</option>
                                  {filteredMedecins.map((medecin) => (
                                    <option key={medecin.id} value={medecin.id}>
                                      Dr. {medecin.prenom} {medecin.nom} - {medecin.specialite}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <div className="info-message">
                                  Aucun médecin disponible pour cette structure ou spécialité.
                                </div>
                              )}
                            </div>
                          )}
                          
                          <div className="form-row">
                            <div className="form-group">
                              <label>Date</label>
                              <div className="icon-input">
                                <i className="bi bi-calendar"></i>
                                <input 
                                  type="date" 
                                  name="date"
                                  value={rdvFormData.date}
                                  onChange={handleRdvFormChange}
                                  min={new Date().toISOString().split('T')[0]}
                                  required
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label>Heure</label>
                              <div className="icon-input">
                                <i className="bi bi-clock"></i>
                                <input 
                                  type="time" 
                                  name="heure"
                                  value={rdvFormData.heure}
                                  onChange={handleRdvFormChange}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          
                          <div className="form-group">
                            <label>Motif de la consultation</label>
                            <textarea 
                              name="motif"
                              value={rdvFormData.motif}
                              onChange={handleRdvFormChange}
                              rows="3"
                              placeholder="Décrivez brièvement le motif de votre consultation..."
                              required
                            ></textarea>
                          </div>
                          
                        
                          
                          
                          
                          <button type="submit" className="btn btn-submit">
                            Demander un rendez-vous
                          </button>
                        </form>
                      </div>
                    </div>
                  )}
                  
                  {/* Messagerie */}
{activeTab === 'messagerie' && (
  <div className="panel">
    <div className="panel-header">
      <h2>Messagerie</h2>
    </div>
    
    <div className="panel-body messaging-panel">
      <div className="messaging-container">
        <div className="conversations-list">
          <div className="conversations-header">
            <h3>Conversations</h3>
          </div>
          
          {conversations.length === 0 ? (
            <div className="no-conversations">
              <p>Aucune conversation</p>
              <small>Vos conversations avec les médecins apparaîtront ici.</small>
            </div>
          ) : (
            <div className="conversations">
              {conversations.map(conversation => (
                <div 
                  key={conversation.id} 
                  className={`conversation-item ${selectedConversation?.id === conversation.id ? 'active' : ''} ${conversation.unreadCount > 0 ? 'unread' : ''}`}
                  onClick={() => setSelectedConversation(conversation)}
                >
                  <div className="conversation-avatar">
                    {conversation.medecin.photo ? (
                      <img src={conversation.medecin.photo} alt={`Dr. ${conversation.medecin.prenom} ${conversation.medecin.nom}`} />
                    ) : (
                      <span>{conversation.medecin.prenom[0]}{conversation.medecin.nom[0]}</span>
                    )}
                  </div>
                  <div className="conversation-info">
                    <h4>Dr. {conversation.medecin.prenom} {conversation.medecin.nom}</h4>
                    <p className="speciality">{conversation.medecin.specialite}</p>
                    <p className="last-message">{conversation.lastMessage || "Nouvelle conversation"}</p>
                  </div>
                  {conversation.unreadCount > 0 && (
                    <div className="unread-badge">{conversation.unreadCount}</div>
                  )}
                </div>
              ))}
            </div>
          )}
          
          <div className="upcoming-appointments">
            <h3>Prochains rendez-vous</h3>
            {getUpcomingAppointments().length === 0 ? (
              <p className="no-appointments">Aucun rendez-vous à venir</p>
            ) : (
              <div className="appointment-list">
                {getUpcomingAppointments().map((appointment, index) => (
                  <div key={index} className="appointment-item">
                    <div className="appointment-info">
                      <h4>Dr. {appointment.medecinNom}</h4>
                      <p>{appointment.date} à {appointment.heure}</p>
                      <p>{appointment.structureName}</p>
                    </div>
                    <button 
                      className="btn btn-sm btn-primary"
                      onClick={() => createConversation(
                        appointment.medecinId,
                        appointment.medecinNom.split(' ')[1], // Nom
                        appointment.medecinNom.split(' ')[0].replace('Dr. ', ''), // Prénom
                        "Médecin"
                      )}
                    >
                      <FontAwesomeIcon icon={faComments} /> Message
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        
        <div className="messages-container">
          {selectedConversation ? (
            <>
              <div className="messages-header">
                <div className="conversation-avatar">
                  {selectedConversation.medecin.photo ? (
                    <img src={selectedConversation.medecin.photo} alt={`Dr. ${selectedConversation.medecin.prenom} ${selectedConversation.medecin.nom}`} />
                  ) : (
                    <span>{selectedConversation.medecin.prenom[0]}{selectedConversation.medecin.nom[0]}</span>
                  )}
                </div>
                <div>
                  <h3>Dr. {selectedConversation.medecin.prenom} {selectedConversation.medecin.nom}</h3>
                  <p>{selectedConversation.medecin.specialite}</p>
                </div>
              </div>
              
              <div className="messages-list">
                {loadingMessages ? (
                  <div className="loading-messages">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Chargement...</span>
                    </div>
                    <p>Chargement des messages...</p>
                  </div>
                ) : messages.length === 0 ? (
                  <div className="no-messages">
                    <div className="icon">
                      <FontAwesomeIcon icon={faComments} size="2x" />
                    </div>
                    <h4>Aucun message</h4>
                    <p>Envoyez un message pour démarrer la conversation.</p>
                  </div>
                ) : (
                  <>
                    {messages.map((message) => {
                      const isOwn = message.senderId === auth.currentUser.uid;
                      return (
                        <div 
                          key={message.id} 
                          className={`message-item ${isOwn ? 'own' : 'other'}`}
                        >
                          {!isOwn && (
                            <div className="message-avatar">
                              {selectedConversation.medecin.photo ? (
                                <img src={selectedConversation.medecin.photo} alt="Dr." />
                              ) : (
                                <span>{selectedConversation.medecin.prenom[0]}{selectedConversation.medecin.nom[0]}</span>
                              )}
                            </div>
                          )}
                          
                          <div className="message-content">
                            {message.text && (
                              <div className="message-text">{message.text}</div>
                            )}
                            
                            {message.attachment && (
                              <div className="message-attachment">
                                {message.attachment.type.startsWith('image/') ? (
                                  <div 
                                    className="attachment-thumbnail" 
                                    onClick={() => openFilePreview(message.attachment)}
                                  >
                                    <img src={message.attachment.url} alt="Pièce jointe" />
                                  </div>
                                ) : (
                                  <div 
                                    className="file-attachment"
                                    onClick={() => openFilePreview(message.attachment)}
                                  >
                                    <FontAwesomeIcon icon={faFile} />
                                    <span>{message.attachment.name}</span>
                                    <FontAwesomeIcon icon={faEye} />
                                  </div>
                                )}
                              </div>
                            )}
                            
                            <div className="message-time">
                              {message.timestamp ? new Date(message.timestamp.toDate()).toLocaleTimeString('fr-FR', {
                                hour: '2-digit',
                                minute: '2-digit'
                              }) : 'Envoi...'}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div ref={messagesEndRef} />
                  </>
                )}
              </div>
              
              <form className="message-form" onSubmit={sendMessage}>
                {attachmentPreview && (
                  <div className="attachment-preview">
                    {attachment.type.startsWith('image/') ? (
                      <img src={attachmentPreview} alt="Aperçu" />
                    ) : (
                      <div className="file-preview">
                        <FontAwesomeIcon icon={faFile} />
                        <span>{attachment.name}</span>
                      </div>
                    )}
                    <button type="button" className="cancel-attachment" onClick={cancelAttachment}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                )}
                
                <div className="message-input-container">
                  <button type="button" className="attach-button">
                    <label htmlFor="file-upload">
                      <FontAwesomeIcon icon={faPaperclip} />
                      <input 
                        id="file-upload" 
                        type="file" 
                        onChange={handleFileChange} 
                        style={{ display: 'none' }}
                        accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      />
                    </label>
                  </button>
                  
                  <input 
                    type="text" 
                    placeholder="Écrivez votre message..." 
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    disabled={sendingMessage}
                  />
                  
                  <button 
                    type="submit" 
                    className="send-button"
                    disabled={(!newMessage.trim() && !attachment) || sendingMessage}
                  >
                    {sendingMessage ? (
                      <FontAwesomeIcon icon={faCircleNotch} spin />
                    ) : (
                      <FontAwesomeIcon icon={faPaperPlane} />
                    )}
                  </button>
                </div>
              </form>
            </>
          ) : (
            <div className="no-conversation-selected">
              <div className="icon">
                <FontAwesomeIcon icon={faComments} size="3x" />
              </div>
              <h3>Sélectionnez une conversation</h3>
              <p>Choisissez une conversation existante ou démarrez une nouvelle conversation avec un médecin de vos rendez-vous.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)}

                  
                  {/* Affiliations */}
                  {activeTab === 'affiliations' && (
                    <div className="panel">
                      <div className="panel-header">
                        <h2>Mes affiliations</h2>
                      </div>
                      
                      <div className="panel-body">
                        {affiliations.length === 0 ? (
                          <div className="empty-state">
                            <div className="icon">
                              <i className="bi bi-building-x"></i>
                            </div>
                            <h3>Vous n'êtes affilié à aucune structure médicale</h3>
                            <button 
                              className="btn btn-action"
                              onClick={() => setActiveTab('nouvelleAffiliation')}
                            >
                              Demander une affiliation
                            </button>
                          </div>
                        ) : (
                          <div className="affiliations-list">
                            {affiliations.map((affiliation) => (
                              <div key={affiliation.id} className={`affiliation-card ${affiliation.statut === 'acceptée' ? 'accepted' : affiliation.statut === 'refusée' ? 'rejected' : 'pending'}`}>
                                <div className="affiliation-icon">
                                  <i className="bi bi-building"></i>
                                </div>
                                
                                <div className="affiliation-details">
                                  <h4>{affiliation.structureNom}</h4>
                                  <p>
                                    <i className="bi bi-calendar"></i> Demande: {formatDate(affiliation.createdAt)}
                                    <i className="bi bi-clock ms-3"></i> Mise à jour: {formatDate(affiliation.updatedAt)}
                                  </p>
                                </div>
                                
                                <div className="affiliation-status">
                                  <span className="status">{affiliation.statut}</span>
                                  
                                  {affiliation.statut === 'acceptée' && (
                                    <button 
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => {
                                        setRdvFormData({...rdvFormData, structureId: affiliation.structureId});
                                        setActiveTab('nouveauRdv');
                                      }}
                                    >
                                      Prendre RDV
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  {/* Nouvelle affiliation */}
                  {activeTab === 'nouvelleAffiliation' && (
                    <div className="panel">
                      <div className="panel-header">
                        <h2>Nouvelle affiliation</h2>
                      </div>
                      
                      <div className="panel-body">
                        <form onSubmit={handleAffiliationSubmit} className="form">
                          <div className="form-group">
                            <label>Structure médicale</label>
                            <div className="search-input">
                              <i className="bi bi-search"></i>
                              <input
                                type="text"
                                placeholder="Rechercher une structure..."
                                value={structureSearchTerm}
                                onChange={(e) => setStructureSearchTerm(e.target.value)}
                              />
                            </div>
                            <select 
                              name="structureId"
                              value={affiliationFormData.structureId}
                              onChange={handleAffiliationFormChange}
                              required
                            >
                              <option value="">Sélectionner une structure</option>
                              {structures
                                .filter(structure => 
                                  structure.nom && structure.nom.toLowerCase().includes(structureSearchTerm.toLowerCase())
                                )
                                .map((structure) => (
                                  <option key={structure.id} value={structure.id}>
                                    {structure.nom}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                          
                          <div className="form-group">
                            <label>Motif de la demande d'affiliation</label>
                            <textarea 
                              name="motif"
                              value={affiliationFormData.motif}
                              onChange={handleAffiliationFormChange}
                              rows="3"
                              placeholder="Expliquez pourquoi vous souhaitez vous affilier à cette structure médicale..."
                              required
                            ></textarea>
                          </div>
                          
                          <div className="info-message">
                            <h4>Qu'est-ce qu'une affiliation ?</h4>
                            <p>
                              L'affiliation à une structure médicale vous permet d'accéder plus facilement à ses services et de bénéficier d'un suivi personnalisé. Votre demande sera examinée par la structure concernée.
                            </p>
                          </div>
                          
                          <button type="submit" className="btn btn-submit">
                            Demander une affiliation
                          </button>
                        </form>
                      </div>
                    </div>
                  )}
                  
                  {/* Sécurité */}
                  {activeTab === 'securite' && (
                    <div className="panel">
                      <div className="panel-header">
                        <h2>Sécurité</h2>
                      </div>
                      
                      <div className="panel-body">
                        <form onSubmit={handleChangePassword} className="form">
                          <div className="info-message warning">
                            <h4>Conseils de sécurité</h4>
                            <p>
                              Utilisez un mot de passe fort contenant au moins 8 caractères, incluant des lettres majuscules, minuscules, des chiffres et des caractères spéciaux.
                            </p>
                          </div>
                          
                          <div className="form-group">
                            <label>Nouveau mot de passe</label>
                            <div className="icon-input">
                              <i className="bi bi-key"></i>
                              <input 
                                type="password" 
                                value={passwordData.newPassword}
                                onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})}
                                required
                                minLength="8"
                              />
                            </div>
                          </div>
                          
                          <div className="form-group">
                            <label>Confirmer le nouveau mot de passe</label>
                            <div className="icon-input">
                              <i className="bi bi-key-fill"></i>
                              <input 
                                type="password" 
                                value={passwordData.confirmPassword}
                                onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})}
                                required
                                minLength="8"
                              />
                            </div>
                          </div>
                          
                          <button type="submit" className="btn btn-submit">
                            Changer le mot de passe
                          </button>
                        </form>
                      </div>
                    </div>
                  )}
                  
                  {/* Notifications */}
                  {activeTab === 'notifications' && <NotificationsPanel />}
                </motion.div>
              </AnimatePresence>
            </main>
          </div>
        )}
      </div>
        </>
      )}
   
   <style jsx>{`
        /* Global styles */
        .patient-dashboard {
          --ms-blue: #0078d4;
          --ms-blue-light: #2b88d8;
          --ms-blue-dark: #106ebe;
          --ms-teal: #038387;
          --ms-red: #d13438;
          --ms-yellow: #ffb900;
          --ms-green: #107c10;
          --ms-purple: #5c2d91;
          --ms-gray-10: #faf9f8;
          --ms-gray-20: #f3f2f1;
          --ms-gray-30: #edebe9;
          --ms-gray-40: #e1dfdd;
          --ms-gray-50: #d2d0ce;
          --ms-gray-60: #c8c6c4;
          --ms-gray-90: #a19f9d;
          --ms-gray-130: #605e5c;
          --ms-gray-160: #323130;
          --ms-gray-190: #201f1e;
          --ms-shadow-1: 0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108);
          --ms-shadow-2: 0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108);
          --ms-shadow-3: 0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108);
          font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif;
          color: var(--ms-gray-160);
          background: var(--ms-gray-10);
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        /* Typography */
        h1, h2, h3, h4, h5, h6 {
          font-weight: 600;
          margin: 0;
          line-height: 1.2;
        }

        h2 {
          font-size: 20px;
          font-weight: 600;
          color: var(--ms-gray-160);
        }

        h3 {
          font-size: 16px;
          font-weight: 600;
        }

        h4 {
          font-size: 14px;
          font-weight: 600;
        }

        p {
          margin: 0 0 8px;
          line-height: 1.5;
        }

        /* Header styles */
        .dashboard-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1px;
          margin: 1px;
          background: var(--ms-blue);
          color: white;
          box-shadow: var(--ms-shadow-1);
          z-index: 100;
          position: relative;
        }

        .dashboard-logo {
          font-size: 20px;
          font-weight: 600;
          letter-spacing: 0.5px;
        }

        .user-menu {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .user-name {
          font-weight: 500;
        }

        .btn-logout {
          background: transparent;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 2px;
          cursor: pointer;
          transition: background 0.2s;
        }

        .btn-logout:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        /* Main container styles */
        .main-container {
          flex: 1;
          display: flex;
          position: relative;
        }

        /* Dashboard layout */
        .dashboard-layout {
          display: flex;
          width: 100%;
          height: calc(100vh - 60px);
        }

        /* Sidebar styles */
        .dashboard-sidebar {
          width: 250px;
          background-color: var(--ms-gray-20);
          box-shadow: var(--ms-shadow-1);
          z-index: 20;
          overflow-y: auto;
          transition: width 0.3s, transform 0.3s;
        }

        .nav-menu {
          padding: 12px 0;
        }

        .nav-menu ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .nav-menu li {
          margin: 2px 0;
        }

        .nav-menu button {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          width: 100%;
          border: none;
          background: transparent;
          text-align: left;
          font-size: 14px;
          color: var(--ms-gray-160);
          cursor: pointer;
          position: relative;
          transition: background 0.2s, color 0.2s;
        }

        .nav-menu button:hover {
          background-color: var(--ms-gray-30);
        }

        .nav-menu li.active button {
          background-color: var(--ms-blue-light);
          color: white;
          font-weight: 500;
        }

        .nav-menu button svg {
          font-size: 16px;
          width: 20px;
        }

        .badge {
          position: absolute;
          right: 16px;
          background: var(--ms-red);
          color: white;
          border-radius: 10px;
          padding: 2px 6px;
          font-size: 11px;
          font-weight: 600;
        }

        /* Content area styles */
        .dashboard-content {
          flex: 1;
          padding: 24px;
          overflow-y: auto;
          background-color: var(--ms-gray-10);
        }

        /* Panel styles */
        .panel {
          background: white;
          border-radius: 4px;
          box-shadow: var(--ms-shadow-1);
          margin-bottom: 24px;
          overflow: hidden;
        }

        .panel-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 24px;
          border-bottom: 1px solid var(--ms-gray-30);
        }

        .panel-body {
          padding: 24px;
        }

        /* Form styles */
        .form {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }

        .form-row {
          display: flex;
          gap: 16px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
          flex: 1;
        }

        .form-group label {
          font-size: 14px;
          font-weight: 500;
          color: var(--ms-gray-160);
        }

        .form-group input,
        .form-group select,
        .form-group textarea {
          padding: 8px 12px;
          border: 1px solid var(--ms-gray-60);
          border-radius: 2px;
          font-size: 14px;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
        }

        .form-group input:focus,
        .form-group select:focus,
        .form-group textarea:focus {
          border-color: var(--ms-blue);
          box-shadow: 0 0 0 1px var(--ms-blue);
        }

        .form-group.error input,
        .form-group.error select,
        .form-group.error textarea {
          border-color: var(--ms-red);
        }

        .icon-input {
          position: relative;
        }

        .icon-input i,
        .icon-input svg {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: var(--ms-gray-130);
        }

        .icon-input input {
          padding-left: 36px;
        }

        .search-input {
          position: relative;
          margin-bottom: 8px;
        }

        .search-input i,
        .search-input svg {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: var(--ms-gray-130);
        }

        .search-input input {
          padding: 8px 12px 8px 36px;
          border: 1px solid var(--ms-gray-60);
          border-radius: 2px;
          font-size: 14px;
          width: 100%;
          outline: none;
        }

        .toggle-label {
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
        }

        .toggle {
          position: relative;
          width: 40px;
          height: 20px;
          background-color: var(--ms-gray-90);
          border-radius: 10px;
          transition: background-color 0.2s;
        }

        .toggle::after {
          content: '';
          position: absolute;
          left: 2px;
          top: 2px;
          width: 16px;
          height: 16px;
          background-color: white;
          border-radius: 50%;
          transition: transform 0.2s;
        }

        .toggle-label input {
          display: none;
        }

        .toggle-label input:checked + .toggle {
          background-color: var(--ms-blue);
        }

        .toggle-label input:checked + .toggle::after {
          transform: translateX(20px);
        }

        .checkbox-group {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }

        .checkbox-label {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          font-size: 14px;
        }

        .checkbox-label input {
          margin: 0;
        }

        /* Button styles */
        .btn {
          padding: 8px 16px;
          border-radius: 2px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s, color 0.2s, border-color 0.2s;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .btn-primary {
          background-color: var(--ms-blue);
          color: white;
          border: 1px solid transparent;
        }

        .btn-primary:hover {
          background-color: var(--ms-blue-dark);
        }

        .btn-secondary {
          background-color: var(--ms-gray-20);
          color: var(--ms-gray-160);
          border: 1px solid var(--ms-gray-60);
        }

        .btn-secondary:hover {
          background-color: var(--ms-gray-30);
        }

        .btn-danger {
          background-color: var(--ms-red);
          color: white;
          border: 1px solid transparent;
        }

        .btn-danger:hover {
          background-color: #a72a2e;
        }

        .btn-submit {
          background-color: var(--ms-blue);
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 2px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
          width: fit-content;
          align-self: flex-start;
        }

        .btn-submit:hover {
          background-color: var(--ms-blue-dark);
        }

        .btn-edit {
          background-color: var(--ms-gray-20);
          color: var(--ms-gray-160);
          border: 1px solid var(--ms-gray-60);
          padding: 6px 12px;
          border-radius: 2px;
          font-size: 14px;
          cursor: pointer;
          transition: background 0.2s;
        }

        .btn-edit:hover {
          background-color: var(--ms-gray-30);
        }

        .btn-cancel {
          background-color: var(--ms-gray-30);
          color: var(--ms-gray-160);
          border: 1px solid var(--ms-gray-60);
          padding: 6px 12px;
          border-radius: 2px;
          font-size: 14px;
          cursor: pointer;
          transition: background 0.2s;
        }

        .btn-cancel:hover {
          background-color: var(--ms-gray-40);
        }

        .btn-action {
          background-color: var(--ms-blue);
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 2px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }

        .btn-action:hover {
          background-color: var(--ms-blue-dark);
        }

        .btn-sm {
          padding: 4px 8px;
          font-size: 12px;
        }

        .btn-link {
          background: transparent;
          color: var(--ms-blue);
          border: none;
          padding: 0;
          font-size: 14px;
          text-decoration: none;
          cursor: pointer;
        }

        .btn-link:hover {
          text-decoration: underline;
        }

        /* Notification styles */
        .notification {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 16px;
          border-radius: 4px;
          margin-bottom: 16px;
          animation: slideIn 0.3s ease;
        }

        .notification.error {
          background-color: #fdebe8;
          border: 1px solid #f1707b;
          color: var(--ms-red);
        }

        .notification.success {
          background-color: #e5f2e5;
          border: 1px solid #8bc48a;
          color: var(--ms-green);
        }

        .close-btn {
          background: transparent;
          border: none;
          color: inherit;
          font-size: 14px;
          cursor: pointer;
        }

        @keyframes slideIn {
          from {
            transform: translateY(-10px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        /* Profile styles */
        .profile-info {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .profile-header {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .avatar {
          width: 80px;
          height: 80px;
          background-color: var(--ms-blue);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          font-weight: 600;
        }

        .info-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }

        .info-item {
          padding: 12px;
          background-color: var(--ms-gray-10);
          border-radius: 4px;
          border: 1px solid var(--ms-gray-30);
        }

        .info-item .label {
          font-size: 12px;
          color: var(--ms-gray-130);
          margin-bottom: 4px;
          display: block;
        }

        .info-item .value {
          font-size: 14px;
          font-weight: 500;
        }

        .info-section {
          background-color: var(--ms-gray-10);
          border-radius: 4px;
          border: 1px solid var(--ms-gray-30);
          padding: 16px;
        }

        .info-section h4 {
          margin-bottom: 12px;
        }

        .tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .tag {
          padding: 4px 12px;
          background-color: var(--ms-blue-light);
          color: white;
          border-radius: 16px;
          font-size: 12px;
          font-weight: 500;
        }

        .empty {
          color: var(--ms-gray-90);
          font-style: italic;
          font-size: 14px;
        }

        .medical-history {
          background-color: white;
          padding: 12px;
          border-radius: 4px;
          border: 1px solid var(--ms-gray-40);
          min-height: 100px;
        }

        /* Appointment styles */
        .appointments {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 16px;
        }

        .appointment-card {
          background-color: white;
          border-radius: 4px;
          box-shadow: var(--ms-shadow-1);
          overflow: hidden;
          display: flex;
          align-items: stretch;
          transition: transform 0.2s, box-shadow 0.2s;
          position: relative;
        }

        .appointment-card:hover {
          transform: translateY(-2px);
          box-shadow: var(--ms-shadow-2);
        }

        .ms-card-highlight {
          width: 4px;
          height: 100%;
        }

        .appointment-date {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 16px;
          background-color: var(--ms-gray-20);
          min-width: 80px;
        }

        .appointment-date .day {
          font-size: 24px;
          font-weight: 600;
          color: var(--ms-gray-160);
        }

        .appointment-date .month {
          font-size: 14px;
          color: var(--ms-gray-130);
          text-transform: uppercase;
        }

        .appointment-details {
          flex: 1;
          padding: 16px;
        }

        .appointment-details h4 {
          margin-bottom: 8px;
          color: var(--ms-gray-160);
        }

        .appointment-details p {
          margin-bottom: 8px;
          color: var(--ms-gray-130);
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .appointment-status {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
        }

        .status {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          text-transform: uppercase;
        }

        .appointment-card.confirmed .status {
          background-color: #e5f2e5;
          color: var(--ms-green);
        }

        .appointment-card.pending .status {
          background-color: #fff8e6;
          color: var(--ms-yellow);
        }

        .appointment-card.cancelled .status {
          background-color: #fdebe8;
          color: var(--ms-red);
        }

        .payment-status {
          font-size: 12px;
          color: var(--ms-gray-130);
        }

        /* Empty state styles */
        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 48px 24px;
          color: var(--ms-gray-130);
        }

        .empty-state .icon {
          font-size: 48px;
          margin-bottom: 16px;
          color: var(--ms-gray-90);
        }

        .empty-state h3 {
          margin-bottom: 16px;
          color: var(--ms-gray-160);
        }

        /* Filter buttons */
        .filter-buttons {
          display: flex;
          gap: 8px;
          margin-bottom: 12px;
          overflow-x: auto;
          padding-bottom: 4px;
        }

        .filter-btn {
          background-color: var(--ms-gray-20);
          border: 1px solid var(--ms-gray-60);
          padding: 6px 12px;
          border-radius: 16px;
          font-size: 12px;
          white-space: nowrap;
          cursor: pointer;
          transition: background 0.2s, border-color 0.2s;
        }

        .filter-btn:hover {
          background-color: var(--ms-gray-30);
        }

        .filter-btn.active {
          background-color: var(--ms-blue);
          color: white;
          border-color: var(--ms-blue);
        }

        /* Info message styles */
        .info-message {
          background-color: var(--ms-gray-10);
          border-left: 4px solid var(--ms-blue);
          padding: 12px 16px;
          margin: 8px 0;
          border-radius: 0 4px 4px 0;
        }

        .info-message h4 {
          margin-bottom: 4px;
          font-size: 14px;
        }

        .info-message p {
          font-size: 14px;
          line-height: 1.5;
        }

        .info-message.warning {
          border-left-color: var(--ms-yellow);
          background-color: #fff8e6;
        }

        /* Affiliation styles */
        .affiliations-list {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 16px;
        }

        .affiliation-card {
          display: flex;
          align-items: center;
          background-color: white;
          border-radius: 4px;
          box-shadow: var(--ms-shadow-1);
          padding: 16px;
          gap: 16px;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .affiliation-card:hover {
          transform: translateY(-2px);
          box-shadow: var(--ms-shadow-2);
        }

        .affiliation-icon {
          font-size: 24px;
          color: var(--ms-blue);
          background-color: var(--ms-gray-20);
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
        }

        .affiliation-details {
          flex: 1;
        }

        .affiliation-details h4 {
          margin-bottom: 8px;
        }

        .affiliation-details p {
          color: var(--ms-gray-130);
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .affiliation-status {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 8px;
        }

        .affiliation-card.accepted .status {
          background-color: #e5f2e5;
          color: var(--ms-green);
        }

        .affiliation-card.pending .status {
          background-color: #fff8e6;
          color: var(--ms-yellow);
        }

        .affiliation-card.rejected .status {
          background-color: #fdebe8;
          color: var(--ms-red);
        }

        /* Loader styles */
        .loader {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          padding: 48px;
          color: var(--ms-gray-130);
        }

        .spinner-border {
          border-width: 0.2em;
          width: 2rem;
          height: 2rem;
          margin-bottom: 16px;
        }

        .text-primary {
          color: var(--ms-blue) !important;
        }

        /* Notification panel styles */
        .notifications-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .notification-item {
          display: flex;
          gap: 16px;
          padding: 16px;
          background-color: white;
          border-radius: 4px;
          box-shadow: var(--ms-shadow-1);
          cursor: pointer;
          transition: background-color 0.2s;
          position: relative;
          overflow: hidden;
        }

        .notification-item:hover {
          background-color: var(--ms-gray-10);
        }

        .notification-item.unread {
          background-color: #eef6fc;
        }

        .notification-item.unread:hover {
          background-color: #e1f0fb;
        }

        .notification-icon {
          font-size: 20px;
          color: var(--ms-blue);
        }

        .notification-content {
          flex: 1;
        }

        .notification-content h4 {
          margin-bottom: 4px;
          font-size: 14px;
        }

        .notification-content p {
          font-size: 14px;
          color: var(--ms-gray-130);
          margin-bottom: 4px;
        }

        .notification-time {
          font-size: 12px;
          color: var(--ms-gray-90);
        }

        .notification-badge {
          position: absolute;
          top: 50%;
          right: 16px;
          transform: translateY(-50%);
          width: 10px;
          height: 10px;
          background-color: var(--ms-blue);
          border-radius: 50%;
        }

        /* Modal styles */
        .payment-modal .modal-content {
          border-radius: 4px;
          border: none;
          box-shadow: var(--ms-shadow-3);
        }

        .payment-modal .modal-header {
          background-color: var(--ms-blue);
          color: white;
          border-bottom: none;
          padding: 12px 16px;
        }

        .payment-modal .modal-header .close {
          color: white;
          opacity: 0.8;
        }

        .payment-modal .modal-body {
          padding: 24px;
        }

        .payment-modal .modal-footer {
          border-top: 1px solid var(--ms-gray-30);
          padding: 16px;
        }

        .payment-details {
          margin-top: 16px;
        }

        .payment-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          padding-bottom: 12px;
          border-bottom: 1px solid var(--ms-gray-30);
        }

        .payment-total {
          display: flex;
          justify-content: space-between;
          font-weight: 600;
          padding-top: 12px;
          font-size: 16px;
        }

        .payment-info {
          margin-top: 24px;
          background-color: var(--ms-gray-10);
          padding: 16px;
          border-left: 4px solid var(--ms-blue);
          border-radius: 0 4px 4px 0;
          display: flex;
          gap: 12px;
        }

        .payment-info i {
          font-size: 24px;
          color: var(--ms-blue);
        }

        /* Mobile Styles */
        .mobile-view {
          background-color: white;
        }

        .mobile-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 16px;
          border-bottom: 1px solid var(--ms-gray-30);
          background-color: white;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .mobile-header-title {
          font-size: 16px;
          font-weight: 600;
        }

        .mobile-header-actions {
          display: flex;
          gap: 16px;
        }

        .mobile-header-btn {
          background: transparent;
          border: none;
          font-size: 20px;
          color: var(--ms-gray-160);
          position: relative;
        }

        .notification-badge {
          position: absolute;
          top: -6px;
          right: -6px;
          background-color: var(--ms-red);
          color: white;
          font-size: 10px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
        }

        .mobile-container {
          padding: 16px;
          padding-bottom: 80px; /* Space for bottom nav */
        }

        .mobile-notification {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px;
          border-radius: 4px;
          margin-bottom: 16px;
          animation: slideIn 0.3s ease;
        }

        .mobile-notification.error {
          background-color: #fdebe8;
          border: 1px solid #f1707b;
          color: var(--ms-red);
        }

        .mobile-notification.success {
          background-color: #e5f2e5;
          border: 1px solid #8bc48a;
          color: var(--ms-green);
        }

        .mobile-loader {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 50vh;
        }

        .mobile-panel {
          background-color: white;
          border-radius: 8px;
          overflow: hidden;
        }

        .mobile-profile-header {
          display: flex;
          align-items: center;
          padding: 16px;
          position: relative;
        }

        .mobile-avatar {
          width: 70px;
          height: 70px;
          background-color: var(--ms-blue);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: 600;
          margin-right: 16px;
        }

        .mobile-edit-btn {
          position: absolute;
          top: 16px;
          right: 16px;
          background-color: var(--ms-gray-20);
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--ms-gray-160);
        }

        .mobile-profile-stats {
          display: flex;
          border-top: 1px solid var(--ms-gray-30);
          border-bottom: 1px solid var(--ms-gray-30);
        }

        .mobile-profile-stats .stat {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 16px 0;
        }

        .mobile-profile-stats .count {
          font-size: 18px;
          font-weight: 600;
          color: var(--ms-gray-160);
        }

        .mobile-profile-stats .label {
          font-size: 12px;
          color: var(--ms-gray-130);
        }

        .mobile-info-section {
          padding: 16px;
          border-bottom: 1px solid var(--ms-gray-30);
        }

        .mobile-info-section h3 {
          margin-bottom: 12px;
          font-size: 16px;
        }

        .mobile-info-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .mobile-info-item .icon {
          color: var(--ms-blue);
          font-size: 18px;
          width: 24px;
        }

        .mobile-info-item .label {
          font-size: 12px;
          color: var(--ms-gray-130);
          display: block;
        }

        .mobile-info-item .value {
          font-size: 14px;
          color: var(--ms-gray-160);
        }

        .mobile-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .mobile-tag {
          padding: 4px 12px;
          background-color: var(--ms-blue-light);
          color: white;
          border-radius: 16px;
          font-size: 12px;
        }

        .mobile-empty {
          color: var(--ms-gray-90);
          font-style: italic;
          font-size: 14px;
        }

        .mobile-form {
          padding: 16px;
        }

        .mobile-form-group {
          margin-bottom: 16px;
        }

        .mobile-form-group label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 8px;
          color: var(--ms-gray-160);
        }

        .mobile-form-group input,
        .mobile-form-group select,
        .mobile-form-group textarea {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid var(--ms-gray-60);
          border-radius: 4px;
          font-size: 14px;
          background-color: white;
        }

        .mobile-form-group input:focus,
        .mobile-form-group select:focus,
        .mobile-form-group textarea:focus {
          border-color: var(--ms-blue);
          outline: none;
          box-shadow: 0 0 0 1px var(--ms-blue);
        }

        .mobile-form-check {
          margin-bottom: 16px;
        }

        .mobile-form-check label {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
        }

        .mobile-info-message {
          padding: 12px;
          background-color: var(--ms-gray-10);
          border-left: 4px solid var(--ms-blue);
          border-radius: 0 4px 4px 0;
          margin: 16px 0;
        }

        .mobile-info-message h4 {
          margin-bottom: 8px;
          font-size: 14px;
          font-weight: 600;
        }

        .mobile-info-message p {
          font-size: 14px;
          line-height: 1.5;
          margin: 0;
        }

        .mobile-info-message.warning {
          border-left-color: var(--ms-yellow);
          background-color: #fff8e6;
        }

        .mobile-search-input {
          position: relative;
          margin-bottom: 8px;
        }

        .mobile-search-input svg,
        .mobile-search-input i {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: var(--ms-gray-130);
        }

        .mobile-search-input input {
          padding-left: 36px;
        }

        .mobile-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 16px;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          border: none;
          cursor: pointer;
          width: 100%;
          transition: background-color 0.2s, color 0.2s;
        }

        .mobile-btn-primary {
          background-color: var(--ms-blue);
          color: white;
        }

        .mobile-btn-primary:hover {
          background-color: var(--ms-blue-dark);
        }

        .mobile-btn-secondary {
          background-color: var(--ms-gray-20);
          color: var(--ms-gray-160);
          border: 1px solid var(--ms-gray-60);
        }

        .mobile-btn-secondary:hover {
          background-color: var(--ms-gray-30);
        }

        .mobile-btn-sm {
          padding: 6px 12px;
          font-size: 12px;
        }

        .mobile-btn-link {
          background: transparent;
          color: var(--ms-blue);
          padding: 0;
        }

        .mobile-profile-actions {
          display: flex;
          gap: 8px;
        }

        .mobile-email {
          color: var(--ms-gray-130);
          font-size: 14px;
        }

        .mobile-appointments {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .mobile-appointment-card {
          display: flex;
          background-color: white;
          border-radius: 8px;
          box-shadow: var(--ms-shadow-1);
          overflow: hidden;
          position: relative;
        }

        .mobile-appointment-card.confirmed {
          border-left: 4px solid var(--ms-green);
        }

        .mobile-appointment-card.pending {
          border-left: 4px solid var(--ms-blue);
        }

        .mobile-appointment-card.cancelled {
          border-left: 4px solid var(--ms-red);
        }

        .mobile-appointment-date {
          background-color: var(--ms-gray-20);
          padding: 16px 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-width: 70px;
        }

        .mobile-appointment-date .day {
          font-size: 20px;
          font-weight: 600;
        }

        .mobile-appointment-date .month {
          font-size: 12px;
          text-transform: uppercase;
          color: var(--ms-gray-130);
        }

        .mobile-appointment-details {
          flex: 1;
          padding: 12px;
        }

        .mobile-appointment-details h4 {
          margin-bottom: 8px;
          font-size: 16px;
        }

        .mobile-appointment-details p {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: var(--ms-gray-130);
          margin-bottom: 4px;
        }

        .mobile-appointment-status {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 8px;
        }

        .mobile-appointment-status .status {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          text-transform: uppercase;
        }

        .mobile-appointment-card.confirmed .status {
          background-color: #e5f2e5;
          color: var(--ms-green);
        }

        .mobile-appointment-card.pending .status {
          background-color: #fff8e6;
          color: var(--ms-yellow);
        }

        .mobile-appointment-card.cancelled .status {
          background-color: #fdebe8;
          color: var(--ms-red);
        }

        .mobile-payment-status {
          font-size: 12px;
          color: var(--ms-gray-130);
        }

        .mobile-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 48px 16px;
          text-align: center;
        }

        .mobile-empty-state svg {
          color: var(--ms-gray-90);
          margin-bottom: 16px;
        }

        .mobile-empty-state h3 {
          margin-bottom: 16px;
          color: var(--ms-gray-130);
        }

        .mobile-messaging-container {
          height: calc(100vh - 140px);
          overflow: hidden;
        }

        .mobile-affiliations {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .mobile-affiliation-card {
          background-color: white;
          border-radius: 8px;
          box-shadow: var(--ms-shadow-1);
          overflow: hidden;
        }

        .mobile-affiliation-card.accepted {
          border-left: 4px solid var(--ms-green);
        }

        .mobile-affiliation-card.pending {
          border-left: 4px solid var(--ms-blue);
        }

        .mobile-affiliation-card.rejected {
          border-left: 4px solid var(--ms-red);
        }

        .mobile-affiliation-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          border-bottom: 1px solid var(--ms-gray-30);
        }

        .mobile-affiliation-header .icon {
          color: var(--ms-blue);
          font-size: 18px;
        }

        .mobile-affiliation-header h4 {
          margin: 0;
          font-size: 16px;
        }

        .mobile-affiliation-details {
          padding: 12px;
        }

        .mobile-affiliation-details p {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: var(--ms-gray-130);
          margin-bottom: 8px;
        }

        .mobile-affiliation-status {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .mobile-affiliation-status .status {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          text-transform: uppercase;
        }

        .mobile-affiliation-card.accepted .status {
          background-color: #e5f2e5;
          color: var(--ms-green);
        }

        .mobile-affiliation-card.pending .status {
          background-color: #fff8e6;
          color: var(--ms-yellow);
        }

        .mobile-affiliation-card.rejected .status {
          background-color: #fdebe8;
          color: var(--ms-red);
        }

        .mobile-notifications-header {
          display: flex;
          justify-content: flex-end;
          padding: 12px;
          border-bottom: 1px solid var(--ms-gray-30);
        }

        .mobile-notifications-list {
          display: flex;
          flex-direction: column;
        }

        .mobile-notification-item {
          display: flex;
          padding: 16px;
          border-bottom: 1px solid var(--ms-gray-30);
          position: relative;
        }

        .mobile-notification-item.unread {
          background-color: #eef6fc;
        }

        .mobile-notification-icon {
          margin-right: 12px;
          color: var(--ms-blue);
          font-size: 18px;
          width: 24px;
        }

        .mobile-notification-content {
          flex: 1;
        }

        .mobile-notification-content h4 {
          margin-bottom: 4px;
          font-size: 14px;
        }

        .mobile-notification-content p {
          font-size: 14px;
          color: var(--ms-gray-130);
          margin-bottom: 4px;
        }

        .mobile-notification-time {
          font-size: 12px;
          color: var(--ms-gray-90);
        }

        .mobile-notification-indicator {
          width: 8px;
          height: 8px;
          background-color: var(--ms-blue);
          border-radius: 50%;
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
        }

        .mobile-bottom-nav {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          height: 56px;
          background-color: white;
          display: flex;
          justify-content: space-around;
          align-items: center;
          border-top: 1px solid var(--ms-gray-30);
          z-index: 1000;
        }

        .mobile-bottom-nav button {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border: none;
          background: transparent;
          color: var(--ms-gray-130);
          font-size: 22px;
          position: relative;
        }

        .mobile-bottom-nav button.active {
          color: var(--ms-blue);
        }

        .mobile-badge {
          position: absolute;
          top: 4px;
          right: 50%;
          transform: translateX(12px);
          background-color: var(--ms-red);
          color: white;
          font-size: 10px;
          min-width: 18px;
          height: 18px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
        }

        .mobile-menu {
          position: fixed;
          top: 0;
          right: 0;
          width: 80%;
          height: 100%;
          background-color: white;
          box-shadow: var(--ms-shadow-3);
          z-index: 2000;
          transform: translateX(100%);
          transition: transform 0.3s;
          display: flex;
          flex-direction: column;
        }

        .mobile-menu.visible {
          transform: translateX(0);
        }

        .mobile-menu-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;
          border-bottom: 1px solid var(--ms-gray-30);
        }

        .mobile-menu-header span {
          font-size: 16px;
          font-weight: 600;
        }

        .mobile-menu-header button {
          background: transparent;
          border: none;
          font-size: 20px;
          color: var(--ms-gray-160);
        }

        .mobile-menu-content {
          padding: 16px;
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .mobile-menu-content button {
          display: flex;
          align-items: center;
          padding: 12px 16px;
          border: none;
          background: transparent;
          text-align: left;
          font-size: 16px;
          color: var(--ms-gray-160);
          border-radius: 4px;
          margin-bottom: 8px;
        }

        .mobile-menu-content button:hover {
          background-color: var(--ms-gray-20);
        }

        .mobile-menu-content button svg {
          margin-right: 12px;
          width: 20px;
          color: var(--ms-gray-130);
        }

        .mobile-menu-divider {
          height: 1px;
          background-color: var(--ms-gray-30);
          margin: 16px 0;
        }

        .mobile-logout-btn {
          margin-top: auto;
          color: var(--ms-red) !important;
        }

        .mobile-logout-btn svg {
          color: var(--ms-red) !important;
        }

        /* Animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        /* Microsoft Fluent UI specific adjustments */
        * {
          box-sizing: border-box;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        :focus-visible {
          outline: 2px solid var(--ms-blue);
          outline-offset: 2px;
        }

        /* Make scrollbars match Microsoft style */
        ::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }

        ::-webkit-scrollbar-thumb {
          background-color: var(--ms-gray-90);
          border-radius: 10px;
          border: 2px solid transparent;
          background-clip: padding-box;
        }

        ::-webkit-scrollbar-thumb:hover {
          background-color: var(--ms-gray-130);
        }

        ::-webkit-scrollbar-track {
          background-color: var(--ms-gray-20);
        }

        /* Calendar styles */
        .view-toggle {
          display: flex;
          gap: 8px;
        }

        .view-btn {
          background-color: var(--ms-gray-20);
          border: 1px solid var(--ms-gray-60);
          color: var(--ms-gray-130);
          width: 36px;
          height: 36px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }

        .view-btn.active {
          background-color: var(--ms-blue);
          color: white;
          border-color: var(--ms-blue);
        }

        .calendar-container {
          display: flex;
          flex-direction: column;
          width: 100%;
          background-color: white;
          border-radius: 8px;
          box-shadow: var(--ms-shadow-1);
          overflow: hidden;
          margin-bottom: 24px;
        }

        .calendar-header {
          padding: 16px;
          background-color: var(--ms-blue);
          color: white;
        }

        .calendar-nav {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .calendar-nav button {
          background: rgba(255, 255, 255, 0.2);
          border: none;
          color: white;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.2s;
        }

        .calendar-nav button:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        .current-month {
          font-size: 18px;
          font-weight: 600;
          text-transform: capitalize;
        }

        .calendar-days {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          background-color: var(--ms-gray-20);
          border-bottom: 1px solid var(--ms-gray-30);
        }

        .calendar-day-name {
          text-align: center;
          padding: 10px 5px;
          font-size: 12px;
          font-weight: 600;
          color: var(--ms-gray-130);
        }

        .calendar-body {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        .calendar-row {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 4px;
          margin-bottom: 4px;
        }

        .calendar-cell {
          position: relative;
          aspect-ratio: 1 / 1;
          padding: 5px;
          border-radius: 6px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;
          background-color: var(--ms-gray-10);
          border: 1px solid var(--ms-gray-30);
          transition: all 0.2s ease;
          min-height: 40px; /* Assurer une hauteur minimale */
        }

        /* Assurer que toutes les cellules sont de même taille */
        .calendar-row::before {
          content: "";
          width: 0;
          padding-bottom: 100%;
          grid-row: 1 / 1;
          grid-column: 1 / 1;
        }

        /* S'assurer que toutes les lignes ont une hauteur fixe */
        .calendar-row > *:first-child {
          grid-row: 1 / 1;
          grid-column: 1 / 1;
        }

        .calendar-cell:hover {
          background-color: var(--ms-gray-20);
          transform: translateY(-2px);
          box-shadow: var(--ms-shadow-1);
        }

        .calendar-cell.disabled {
          opacity: 0.4;
          cursor: default;
          pointer-events: none;
        }

        .calendar-cell.today {
          background-color: #deecf9;
          border: 2px solid var(--ms-blue);
        }

        .calendar-cell.selected {
          background-color: var(--ms-blue);
          color: white;
          border-color: var(--ms-blue);
        }

        .calendar-date {
          font-size: 16px;
          font-weight: 600;
          padding: 2px 0;
          width: 100%;
          text-align: center;
        }

        .appointment-count {
          position: absolute;
          bottom: 5px;
          right: 5px;
          background-color: var(--ms-blue);
          color: white;
          min-width: 20px;
          height: 20px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          font-weight: 600;
          padding: 0 5px;
        }

        .calendar-cell.selected .appointment-count {
          background-color: white;
          color: var(--ms-blue);
        }

        .selected-date-appointments {
          padding: 16px;
          border-top: 1px solid var(--ms-gray-30);
        }

        .selected-date-appointments h3 {
          margin-bottom: 16px;
          font-size: 16px;
          font-weight: 600;
          color: var(--ms-blue);
          text-align: center;
        }

        .appointments-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .appointment-mini-card {
          display: flex;
          gap: 12px;
          padding: 12px;
          background-color: white;
          border-radius: 6px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          border-left: 4px solid var(--ms-blue);
          transition: transform 0.2s;
        }

        .appointment-mini-card:hover {
          transform: translateY(-2px);
          box-shadow: var(--ms-shadow-2);
        }

        .appointment-mini-card.confirmed {
          border-left-color: var(--ms-green);
        }

        .appointment-mini-card.cancelled {
          border-left-color: var(--ms-red);
        }

        .appointment-mini-time {
          background-color: var(--ms-gray-20);
          border-radius: 4px;
          padding: 8px;
          min-width: 60px;
          text-align: center;
          font-weight: 600;
          font-size: 14px;
          color: var(--ms-gray-160);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .appointment-mini-details {
          flex: 1;
        }

        .appointment-mini-details h4 {
          font-size: 14px;
          margin-bottom: 4px;
          color: var(--ms-gray-160);
        }

        .appointment-mini-details p {
          font-size: 13px;
          color: var(--ms-gray-130);
          margin-bottom: 8px;
        }

        .appointment-mini-status .status {
          font-size: 12px;
          padding: 3px 8px;
          border-radius: 12px;
          text-transform: uppercase;
          font-weight: 500;
        }

        .appointment-mini-card.confirmed .status {
          background-color: #e5f2e5;
          color: var(--ms-green);
        }

        .appointment-mini-card.pending .status {
          background-color: #fff8e6;
          color: var(--ms-yellow);
        }

        .appointment-mini-card.cancelled .status {
          background-color: #fdebe8;
          color: var(--ms-red);
        }

        .no-appointments {
          text-align: center;
          padding: 20px;
          color: var(--ms-gray-130);
          font-style: italic;
          background-color: var(--ms-gray-10);
          border-radius: 4px;
        }

        /* Styles spécifiques mobile */
        .mobile-calendar-toggle {
          display: flex;
          margin-bottom: 16px;
          background-color: var(--ms-gray-20);
          border-radius: 8px;
          overflow: hidden;
        }

        .mobile-calendar-toggle button {
          flex: 1;
          padding: 12px 8px;
          border: none;
          background: transparent;
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          color: var(--ms-gray-130);
        }

        .mobile-calendar-toggle button.active {
          background-color: var(--ms-blue);
          color: white;
        }

        /* Adaptations responsives */
        @media (max-width: 767px) {
          .calendar-day-name {
            font-size: 11px;
            padding: 8px 2px;
          }
          
          .calendar-date {
            font-size: 14px;
          }
          
          .calendar-cell {
            padding: 2px;
            min-height: 40px;
          }
          
          .appointment-count {
            min-width: 18px;
            height: 18px;
            font-size: 10px;
          }
          
          .calendar-nav button {
            width: 32px;
            height: 32px;
          }
          
          .current-month {
            font-size: 16px;
          }
          
          .selected-date-appointments h3 {
            font-size: 15px;
          }
          
          .appointment-mini-time {
            min-width: 50px;
            padding: 6px;
            font-size: 13px;
          }
          
          .appointment-mini-details h4 {
            font-size: 13px;
          }
          
          .appointment-mini-details p {
            font-size: 12px;
          }
        }

        /* Pour très petits écrans */
        @media (max-width: 360px) {
          .calendar-day-name {
            font-size: 10px;
            padding: 6px 1px;
          }
          
          .calendar-cell {
            padding: 1px;
            min-height: 35px;
          }
          
          .calendar-date {
            font-size: 12px;
          }
          
          .appointment-count {
            min-width: 16px;
            height: 16px;
            font-size: 9px;
            right: 2px;
            bottom: 2px;
          }
        }

        /* Messaging styles */
.messaging-panel {
  padding: 0;
  height: calc(80vh - 120px);
}

.messaging-container {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.conversations-list {
  width: 300px;
  border-right: 1px solid var(--ms-gray-30);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.conversations-header {
  padding: 16px;
  border-bottom: 1px solid var(--ms-gray-30);
}

.conversations-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.conversations {
  flex: 1;
  overflow-y: auto;
}

.conversation-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ms-gray-30);
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
}

.conversation-item:hover {
  background-color: var(--ms-gray-10);
}

.conversation-item.active {
  background-color: var(--ms-gray-20);
}

.conversation-item.unread {
  background-color: #eef6fc;
}

.conversation-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--ms-blue);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 12px;
  overflow: hidden;
}

.conversation-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.conversation-info {
  flex: 1;
  min-width: 0;
}

.conversation-info h4 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-info .speciality {
  font-size: 12px;
  color: var(--ms-gray-130);
  margin: 0 0 4px;
}

.conversation-info .last-message {
  font-size: 12px;
  color: var(--ms-gray-130);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.unread-badge {
  background-color: var(--ms-blue);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.upcoming-appointments {
  padding: 16px;
  border-top: 1px solid var(--ms-gray-30);
  max-height: 40%;
  overflow-y: auto;
}

.upcoming-appointments h3 {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
}

.appointment-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.appointment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background-color: var(--ms-gray-10);
  border-radius: 4px;
  border: 1px solid var(--ms-gray-30);
}

.appointment-info h4 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
}

.appointment-info p {
  margin: 0;
  font-size: 12px;
  color: var(--ms-gray-130);
}

.no-appointments {
  color: var(--ms-gray-90);
  font-style: italic;
  font-size: 14px;
}

.messages-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.messages-header {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid var(--ms-gray-30);
}

.messages-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.messages-header p {
  margin: 0;
  font-size: 14px;
  color: var(--ms-gray-130);
}

.messages-list {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message-item {
  display: flex;
  gap: 12px;
  max-width: 80%;
}

.message-item.own {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.message-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--ms-blue);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  overflow: hidden;
}

.message-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.message-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.message-text {
  padding: 12px 16px;
  border-radius: 18px;
  font-size: 14px;
  background-color: var(--ms-gray-20);
  color: var(--ms-gray-160);
  word-break: break-word;
}

.message-item.own .message-text {
  background-color: var(--ms-blue);
  color: white;
}

.message-attachment img {
  max-width: 250px;
  max-height: 200px;
  border-radius: 8px;
  object-fit: cover;
}

.file-attachment {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: var(--ms-gray-20);
  border-radius: 18px;
  color: var(--ms-gray-160);
  text-decoration: none;
  transition: background-color 0.2s;
}

.message-item.own .file-attachment {
  background-color: var(--ms-blue);
  color: white;
}

.file-attachment:hover {
  background-color: var(--ms-gray-30);
}

.message-item.own .file-attachment:hover {
  background-color: var(--ms-blue-dark);
}

.message-time {
  font-size: 11px;
  color: var(--ms-gray-90);
  align-self: flex-end;
  margin-top: 2px;
}

.message-item.own .message-time {
  align-self: flex-start;
}

.message-form {
  padding: 16px;
  border-top: 1px solid var(--ms-gray-30);
}

.attachment-preview {
  margin-bottom: 12px;
  position: relative;
  display: inline-block;
}

.attachment-preview img {
  max-width: 100px;
  max-height: 100px;
  border-radius: 8px;
  object-fit: cover;
}

.file-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: var(--ms-gray-20);
  border-radius: 8px;
  font-size: 14px;
}

.cancel-attachment {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--ms-gray-160);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.message-input-container {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: var(--ms-gray-20);
  border-radius: 24px;
  padding: 8px 12px;
}

.message-input-container input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 8px 0;
  font-size: 14px;
  outline: none;
}

.attach-button, .send-button {
  background: transparent;
  border: none;
  color: var(--ms-gray-130);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s;
}

.attach-button:hover, .send-button:hover {
  background-color: var(--ms-gray-30);
}

.send-button {
  color: var(--ms-blue);
}

.send-button:hover {
  color: var(--ms-blue-dark);
}

.send-button:disabled {
  color: var(--ms-gray-90);
  cursor: not-allowed;
}

.loading-messages, .no-messages {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--ms-gray-130);
  text-align: center;
  padding: 24px;
}

.loading-messages .spinner-border {
  margin-bottom: 16px;
}

.no-messages .icon {
  color: var(--ms-gray-90);
  margin-bottom: 16px;
}

.no-messages h4 {
  margin-bottom: 8px;
  color: var(--ms-gray-160);
}

.no-conversation-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--ms-gray-130);
  text-align: center;
  padding: 24px;
}

.no-conversation-selected .icon {
  color: var(--ms-gray-90);
  margin-bottom: 16px;
}

.no-conversation-selected h3 {
  margin-bottom: 8px;
  color: var(--ms-gray-160);
}

.no-conversations {
  padding: 24px;
  text-align: center;
  color: var(--ms-gray-130);
}

.no-conversations p {
  margin-bottom: 8px;
  font-weight: 500;
}

.no-conversations small {
  font-size: 12px;
}

/* Mobile messaging styles */
.mobile-chat-view {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 140px);
}

.mobile-chat-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-bottom: 1px solid var(--ms-gray-30);
}

.back-button {
  background: transparent;
  border: none;
  font-size: 18px;
  color: var(--ms-gray-160);
}

.mobile-chat-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-chat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--ms-blue);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  overflow: hidden;
}

.mobile-chat-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-chat-user h4 {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
}

.mobile-chat-user p {
  margin: 0;
  font-size: 12px;
  color: var(--ms-gray-130);
}

.mobile-messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.mobile-loading-messages {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
  color: var(--ms-gray-130);
}

.mobile-no-messages {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  color: var(--ms-gray-130);
  text-align: center;
}

.mobile-messages-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mobile-message-item {
  display: flex;
  gap: 8px;
  max-width: 90%;
}

.mobile-message-item.own {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.mobile-message-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: var(--ms-blue);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  overflow: hidden;
}

.mobile-message-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-message-bubble {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-message-text {
  padding: 10px 14px;
  border-radius: 18px;
  font-size: 14px;
  background-color: var(--ms-gray-20);
  color: var(--ms-gray-160);
  word-break: break-word;
}

.mobile-message-item.own .mobile-message-text {
  background-color: var(--ms-blue);
  color: white;
}

.mobile-message-attachment img {
  max-width: 200px;
  max-height: 150px;
  border-radius: 8px;
  object-fit: cover;
}

.mobile-file-attachment {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background-color: var(--ms-gray-20);
  border-radius: 18px;
  color: var(--ms-gray-160);
  text-decoration: none;
  font-size: 14px;
}

.mobile-message-item.own .mobile-file-attachment {
  background-color: var(--ms-blue);
  color: white;
}

.mobile-message-time {
  font-size: 10px;
  color: var(--ms-gray-90);
  align-self: flex-end;
  margin-top: 2px;
}

.mobile-message-item.own .mobile-message-time {
  align-self: flex-start;
}

.mobile-message-form {
  padding: 12px;
  border-top: 1px solid var(--ms-gray-30);
}

.mobile-attachment-preview {
  margin-bottom: 12px;
  position: relative;
  display: inline-block;
}

.mobile-attachment-preview img {
  max-width: 80px;
  max-height: 80px;
  border-radius: 8px;
  object-fit: cover;
}

.mobile-file-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: var(--ms-gray-20);
  border-radius: 8px;
  font-size: 12px;
}

.mobile-cancel-attachment {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--ms-gray-160);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
}

.mobile-message-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: var(--ms-gray-20);
  border-radius: 24px;
  padding: 6px 10px;
}

.mobile-message-input-container input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 8px 0;
  font-size: 14px;
  outline: none;
}

.mobile-attach-button, .mobile-send-button {
  background: transparent;
  border: none;
  color: var(--ms-gray-130);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.mobile-send-button {
  color: var(--ms-blue);
}

.mobile-send-button:disabled {
  color: var(--ms-gray-90);
  cursor: not-allowed;
}

.mobile-conversations-header {
  padding: 16px;
  border-bottom: 1px solid var(--ms-gray-30);
}

.mobile-conversations-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.mobile-conversations-list {
  display: flex;
  flex-direction: column;
}

.mobile-conversation-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid var(--ms-gray-30);
  position: relative;
}

.mobile-conversation-item.unread {
  background-color: #eef6fc;
}

.mobile-conversation-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--ms-blue);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 16px;
  overflow: hidden;
}

.mobile-conversation-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-conversation-info {
  flex: 1;
  min-width: 0;
}

.mobile-conversation-info h4 {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-speciality {
  font-size: 12px;
  color: var(--ms-gray-130);
  margin: 0 0 4px;
}

.mobile-last-message {
  font-size: 14px;
  color: var(--ms-gray-130);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-unread-badge {
  background-color: var(--ms-blue);
  color: white;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  padding: 0 6px;
}

.mobile-section-header {
  padding: 16px 16px 8px;
  border-bottom: 1px solid var(--ms-gray-30);
}

.mobile-section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--ms-gray-130);
}

.mobile-upcoming-appointments {
  padding: 0 16px;
}

.mobile-appointment-chat-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid var(--ms-gray-30);
}

.mobile-appointment-chat-info h4 {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
}

.mobile-appointment-chat-info p {
  margin: 0 0 2px;
  font-size: 14px;
  color: var(--ms-gray-130);
}

.mobile-structure-name {
  font-size: 12px !important;
}

.mobile-chat-btn {
  background-color: var(--ms-blue);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.mobile-chat-btn:hover {
  background-color: var(--ms-blue-dark);
}

/* Styles pour le modal de prévisualisation de fichiers */
.file-preview-modal .modal-content {
  border-radius: 8px;
  border: none;
  box-shadow: var(--ms-shadow-3);
}

.file-preview-modal .modal-header {
  border-bottom: 1px solid var(--ms-gray-30);
  padding: 16px;
}

.file-preview-modal .modal-title {
  font-size: 18px;
  font-weight: 600;
}

.file-preview-modal .modal-body {
  padding: 0;
}

.file-preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  min-height: 200px;
}

.img-preview {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
}

.pdf-preview {
  width: 100%;
  height: 70vh;
  border: none;
}

.video-preview {
  max-width: 100%;
  max-height: 70vh;
}

.audio-preview {
  width: 100%;
  margin: 24px 0;
}

.unsupported-file {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: var(--ms-gray-130);
  text-align: center;
  padding: 48px 24px;
}

.attachment-thumbnail, .mobile-attachment-thumbnail {
  cursor: pointer;
  transition: transform 0.2s;
  position: relative;
}

.attachment-thumbnail:hover, .mobile-attachment-thumbnail:hover {
  transform: scale(1.05);
}

.attachment-thumbnail::after, .mobile-attachment-thumbnail::after {
  content: "Aperçu";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 12px;
  padding: 4px;
  opacity: 0;
  transition: opacity 0.2s;
  text-align: center;
}

.attachment-thumbnail:hover::after, .mobile-attachment-thumbnail:hover::after {
  opacity: 1;
}

.file-attachment, .mobile-file-attachment {
  cursor: pointer;
}
  /* Styles pour le modal de prévisualisation de fichiers */
.file-preview-modal .modal-content {
  border-radius: 8px;
  border: none;
  box-shadow: var(--ms-shadow-3);
}

.file-preview-modal .modal-header {
  border-bottom: 1px solid var(--ms-gray-30);
  padding: 16px;
}

.file-preview-modal .modal-title {
  font-size: 18px;
  font-weight: 600;
}

.file-preview-modal .modal-body {
  padding: 0;
}

.file-preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  min-height: 200px;
}

.img-preview {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
}

.pdf-preview {
  width: 100%;
  height: 70vh;
  border: none;
}

.video-preview {
  max-width: 100%;
  max-height: 70vh;
}

.audio-preview {
  width: 100%;
  margin: 24px 0;
}

.unsupported-file {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: var(--ms-gray-130);
  text-align: center;
  padding: 48px 24px;
}

.attachment-thumbnail, .mobile-attachment-thumbnail {
  cursor: pointer;
  transition: transform 0.2s;
  position: relative;
}

.attachment-thumbnail:hover, .mobile-attachment-thumbnail:hover {
  transform: scale(1.05);
}

.attachment-thumbnail::after, .mobile-attachment-thumbnail::after {
  content: "Aperçu";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 12px;
  padding: 4px;
  opacity: 0;
  transition: opacity 0.2s;
  text-align: center;
}

.attachment-thumbnail:hover::after, .mobile-attachment-thumbnail:hover::after {
  opacity: 1;
}

.file-attachment, .mobile-file-attachment {
  cursor: pointer;
}

      `}</style>


      {/* Modal de paiement */}
      <PaymentModal />
<FilePreviewModal />
      {/* Mobile menu */}
      {showMobileMenu && <MobileMenu />}
    </div>
  );
};

export default PatientDashboard;


